'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var reactBootstrapTypeahead = require('react-bootstrap-typeahead');
var DatePicker = require('react-datepicker');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var DatePicker__default = /*#__PURE__*/_interopDefaultLegacy(DatePicker);

const cleanTitle = function () {
  let title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let group = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (title && group && title.startsWith('custom_data/')) {
    group = group.charAt(0).toUpperCase() + group.slice(1);
    title = title.replace('custom_data/', '');
    return `${group} Custom Data: ${title}`;
  }
  switch (title) {
    case 'board':
      return 'Board';
    case 'bootloader_version':
      return 'Bootloader Version';
    case 'brand':
      return 'Brand';
    case 'build':
      return 'Build';
    case 'build_number':
      return 'Build Number';
    case 'build_id':
      return 'Build ID';
    case 'build_type':
      return 'Build Type';
    case 'carrier':
      return 'Carrier';
    case 'version':
    case 'cf_bundle_version':
    case 'cf_bundle_short_version_string':
      return 'App Version';
    case 'version_code':
      return 'App Version Code';
    case 'version_name':
      return 'App Version Name';
    case 'cpu':
      return 'CPU';
    case 'current_carrier':
      return 'Current Carrier';
    case 'current_time':
      return 'Current Time';
    case 'device':
      return 'Device';
    case 'debug':
      return 'App Build Type';
    case 'hardware':
      return 'Device Hardware';
    case 'locale_country_code':
      return 'Country';
    case 'locale_language_code':
      return 'Language';
    case 'manufacturer':
      return 'Manufacturer';
    case 'model':
      return 'Device Model';
    case 'network_type':
      return 'Network Type';
    case 'os_api_level':
      return 'OS API Level';
    case 'os_build':
      return 'OS Build';
    case 'os_name':
      return 'OS Name';
    case 'os_version':
      return 'OS Version';
    case 'product':
      return 'Product';
    case 'radio_version':
      return 'Radio Version';
    case 'user_agent':
      return 'User Agent';
    case 'Fan':
      return 'New Fan';
    case 'ReclaimedFan':
      return 'Shifted to Fan';
    case 'RepeatFan':
      return 'Repeat Fan';
    case 'Opportunity':
      return 'New Risk';
    case 'LostFan':
      return 'Shifted to Risk';
    case 'RepeatOpportunity':
      return 'Repeat Risk';
    default:
      return title && title != null ? title : '';
  }
};
const getAttributeType = (value, attributes) => {
  if (value && value.includes('random/')) {
    return 'number';
  }
  if (value && value.includes('custom_data/') && attributes) {
    const [group,, key] = value.split('/');
    if (attributes[group] && attributes[group].fields) {
      const found = attributes[group].fields.find(field => field.key === `custom_data.${key}`);
      if (found) {
        return found.type;
      }
    }
  }
  switch (value) {
    case 'application/cf_bundle_short_version_string':
    case 'application/cf_bundle_version':
    case 'application/version_name':
    case 'application/version':
    case 'sdk/version':
    case 'device/os_version':
      return 'version';
    case 'application/debug':
    case 'is_update/build_number':
    case 'is_update/build':
    case 'is_update/cf_bundle_short_version_string':
    case 'is_update/cf_bundle_version':
    case 'is_update/version_code':
    case 'is_update/version_name':
    case 'is_update/version':
      return 'boolean';
    case '/current_time':
    case '/local_time':
    case 'local_time':
    case 'current_time':
      return 'datetime';
    case 'code_point/invokes/time_ago':
    case 'code_point/last_invoked_at/total':
    case 'interactions/invokes/time_ago':
    case 'interactions/last_invoked_at/total':
    case 'time_at_install/build_number':
    case 'time_at_install/build':
    case 'time_at_install/cf_bundle_short_version_string':
    case 'time_at_install/cf_bundle_version':
    case 'time_at_install/total':
    case 'time_at_install/version_code':
    case 'time_at_install/version':
    case 'time_since_install/total':
    case 'time_since_install/version':
      return 'duration';
    case 'device/os_api_level':
    case 'device/utc_offset':
    case '/utc_offset':
    case 'utc_offset':
    case 'application/build_number':
    case 'application/build':
    case 'application/version_code':
    case 'code_point/invokes/build_number':
    case 'code_point/invokes/build':
    case 'code_point/invokes/cf_bundle_short_version_string':
    case 'code_point/invokes/cf_bundle_version':
    case 'code_point/invokes/version_code':
    case 'code_point/invokes/version_name':
    case 'code_point/invokes/version':
    case 'code_point/invokes/total':
    case 'interactions/invokes/build_number':
    case 'interactions/invokes/build':
    case 'interactions/invokes/cf_bundle_short_version_string':
    case 'interactions/invokes/cf_bundle_version':
    case 'interactions/invokes/version_code':
    case 'interactions/invokes/version_name':
    case 'interactions/invokes/version':
    case 'interactions/invokes/total':
      return 'number';
    case 'device/board':
    case 'device/bootloader_version':
    case 'device/brand':
    case 'device/build_id':
    case 'device/build_type':
    case 'device/carrier':
    case 'device/cpu':
    case 'device/current_carrier':
    case 'device/device':
    case 'device/hardware':
    case 'device/locale_country_code':
    case 'device/locale_language_code':
    case 'device/locale_raw':
    case 'device/manufacturer':
    case 'device/model':
    case 'device/network_type':
    case 'device/os_build':
    case 'device/os_name':
    case 'device/product':
    case 'device/radio_version':
    case 'device/uuid':
    case 'device/user_agent':
    case 'person/email':
    case 'person/name':
    case 'interactions/answers/id':
    case 'interactions/answers/value':
    case 'interaction_response_targeting/answers/id':
    case 'interaction_response_targeting/answers/value':
      return 'string';
    case 'fs_state/Fan':
    case 'fs_state/LostFan':
    case 'fs_state/Opportunity':
    case 'fs_state/ReclaimedFan':
    case 'fs_state/RepeatFan':
    case 'fs_state/RepeatOpportunity':
      return 'fan_signal';
    case 'range':
    case 'nps':
      return 'survey_question_number';
    case 'singleline':
    case 'multiline':
    case 'multiselect_other':
    case 'multichoice_other':
      return 'survey_question_text';
    case 'multiselect':
    case 'multichoice':
    case 'Survey':
      return 'survey_question';
    case 'TextModal':
    case 'dismiss':
    case 'interaction':
      return 'note_action';
    default:
      console.warn('Unknown Attribute Type:', value);
      return 'string';
  }
};
const getDefaultValueForType = type => {
  switch (type) {
    case 'version':
      return '1.0.0';
    case 'boolean':
      return true;
    case 'datetime':
      return Date.now();
    case 'duration':
      return 0;
    case 'number':
      return 0;
    case 'string':
      return '';
    case 'fan_signal':
      return undefined;
    default:
      console.error('Unknown type to get default type for:', type);
      return undefined;
  }
};
const versionOnly = e => {
  const code = e.which || e.keyCode || 0;
  if ([46, 8, 9, 27, 13, 110].includes(code)) {
    return;
  }
  if ([190].includes(code)) {
    return;
  }
  if ((e.ctrlKey || e.metaKey) === true && [65, 67, 86, 88, 90].includes(code)) {
    return;
  }
  if (code >= 35 && code <= 40) {
    return;
  }
  if ((e.shiftKey || code < 48 || code > 57) && (code < 96 || code > 105)) {
    e.preventDefault();
  }
};
const integerOnly = e => {
  const code = e.which || e.keyCode || 0;
  if ([46, 8, 9, 27, 13, 110].includes(code)) {
    return;
  }
  if ((e.ctrlKey || e.metaKey) === true && [65, 67, 86, 88, 90].includes(code)) {
    return;
  }
  if (code >= 35 && code <= 40) {
    return;
  }
  if ((e.shiftKey || code < 48 || code > 57) && (code < 96 || code > 105)) {
    e.preventDefault();
  }
};
const numericOnly = e => {
  const code = e.which || e.keyCode || 0;
  if ([46, 8, 9, 27, 13, 110].includes(code)) {
    return;
  }
  if ([190].includes(code) && !(e.currentTarget.value && /\./g.test(e.currentTarget.value))) {
    return;
  }
  if ((e.ctrlKey || e.metaKey) === true && [65, 67, 86, 88, 90].includes(code)) {
    return;
  }
  if (code >= 35 && code <= 40) {
    return;
  }
  if ((e.shiftKey || code < 48 || code > 57) && (code < 96 || code > 105)) {
    e.preventDefault();
  }
};
const s4 = function s4() {
  return Math.trunc((1 + Math.random()) * 0x10000).toString(16).slice(1);
};
const gguid = () => `${s4()}${s4()}-${s4()}-4${s4().slice(0, 3)}-${s4()}-${s4()}${s4()}${s4()}`;
const parseDuration = function () {
  let seconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  const d = Math.floor(seconds / 86400);
  const h = Math.floor(seconds / 3600 % 24);
  const m = Math.floor(seconds / 60 % 60);
  const s = Math.floor(seconds % 60);
  let input;
  let drop;
  if (d !== 0) {
    drop = 'days';
    input = d;
  } else if (h !== 0) {
    drop = 'hours';
    input = h;
  } else if (m !== 0) {
    drop = 'minutes';
    input = m;
  } else {
    drop = 'seconds';
    input = s;
  }
  return [input, drop];
};
const classNames = function () {
  let classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!classes || typeof classes !== 'object') {
    return '';
  }
  const output = [];
  for (const [key, value] of Object.entries(classes)) {
    if (value && !output.includes(key)) {
      output.push(key);
    }
  }
  return output.join(' ');
};
const convertUTCToLocalDate = date => {
  if (!date) {
    return date;
  }
  date = new Date(date);
  date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  return date;
};

const consolidateRules = _ref => {
  let {
    values,
    interactions,
    attributes
  } = _ref;
  const rules = [];
  if (!values || values.length === 0) {
    return rules;
  }
  for (const rule of values) {
    let [key, detail] = Object.entries(rule).flat();
    if (typeof detail !== 'object') {
      console.warn('Unexpected Loose Rule:', key, detail);
      detail = {
        $eq: detail
      };
    }
    if (key === '$not' && Array.isArray(detail)) {
      if (detail.length > 1) {
        console.error('Unsupported $not with multiple clauses inside! Taking the frist clause only.');
      }
      [detail] = detail;
    }
    if (key === '$or' && Array.isArray(detail)) {
      const bulkValue = [];
      let lastKey;
      let lastGroup;
      let lastComparator;
      for (const item of detail) {
        const [target, logic] = Object.entries(item)[0];
        let bulkGroup = '';
        let bulkKey = '';
        if (target.includes('/custom_data/')) {
          [bulkGroup,, bulkKey] = target.split('/');
          bulkKey = `custom_data/${bulkKey}`;
        } else {
          [bulkGroup, bulkKey] = target.split('/');
        }
        const [bulkComparator, value] = Object.entries(logic)[0];
        if (lastKey && lastKey !== bulkKey) {
          console.error(`Key Mistmatch in bulk-upload rule, expected "${lastKey}" but got "${bulkKey}"`);
        }
        if (lastGroup && lastGroup !== bulkGroup) {
          console.error(`Group Mistmatch in bulk-upload rule, expected "${lastGroup}" but got "${bulkGroup}"`);
        }
        if (lastGroup && lastGroup !== bulkGroup) {
          console.error(`Comparator Mistmatch in bulk-upload rule, expected "${lastComparator}" but got "${bulkComparator}"`);
        }
        lastKey = bulkKey;
        lastGroup = bulkGroup;
        lastComparator = bulkComparator;
        bulkValue.push(value);
      }
      const id = gguid();
      const data = {
        id,
        group: 'bulk-upload',
        key: '',
        type: 'parent',
        details: [{
          parent: id,
          id: gguid(),
          comparator: lastComparator,
          value: bulkValue,
          key: lastKey,
          group: lastGroup,
          type: getAttributeType(`${lastGroup}/${lastKey}`, attributes),
          duplicates: 0
        }]
      };
      rules.push(data);
      continue;
    }
    for (let [comparator, value] of Object.entries(detail)) {
      if (key === '$not') {
        key = comparator;
        [comparator] = Object.keys(detail);
        if (typeof detail[comparator] === 'object') {
          [value] = Object.values(detail[comparator]);
        } else {
          value = detail[comparator];
        }
        comparator = '$notcontains';
      } else if (comparator === '$not') {
        [comparator] = Object.keys(detail.$not);
        value = detail.$not[comparator];
        comparator = '$notcontains';
      }
      if (key.includes('invokes/time_ago')) {
        key = key.replace('invokes/time_ago', 'last_invoked_at/total');
      }
      let group = '';
      if (key.includes('/')) {
        [group] = key.split('/');
      }
      let suffix;
      if ((group === 'interactions' || group === 'code_point') && key.includes('/')) {
        const verb = key.match(/(last_invoked_at|invokes|answers)/) || [];
        const noun = key.match(/\/(total|cf_bundle_version|cf_bundle_short_version_string|version_code|version|version_name|build|build_number|time_ago|value|id)$/) || [];
        if (verb.length <= 0 || noun.length <= 0) {
          console.error('Skipping Unknown Rule Configuration:', key);
          continue;
        }
        suffix = `${verb[0]}/${noun[1]}`;
        key = key.replace(/\/(last_invoked_at|invokes|answers)\/(total|cf_bundle_version|cf_bundle_short_version_string|version_code|version|version_name|build|build_number|time_ago|value|id)$/, '');
      }
      key = key.slice(Math.max(0, key.indexOf('/') + 1));
      let type = 'string';
      if (group === 'random') {
        key = key.replace(/\/(percent)$/, '');
        type = 'number';
      }
      type = ['code_point', 'interactions', 'fs_state'].includes(group) ? 'parent' : getAttributeType(`${group}/${key}`, attributes);
      if (typeof value === 'object' && typeof value._type !== 'undefined') {
        type = value._type;
        if (type === 'datetime' || type === 'duration') {
          value = value.sec;
        }
        if (type === 'version') {
          value = value.version;
        }
      }
      if (key === 'com.apptentive#Survey#launch' || key === 'com.apptentive#TextModal#launch' || key === 'com.apptentive#EnjoymentDialog#no' || key === 'com.apptentive#EnjoymentDialog#yes' || key === 'com.apptentive#EnjoymentDialog#launch' || key === 'com.apptentive#RatingDialog#launch' || key === 'com.apptentive#AppleRatingDialog#not_shown'
      || key === 'com.apptentive#AppleRatingDialog#request'
      || key === 'com.apptentive#AppleRatingDialog#shown' || key === 'com.apptentive#InAppRatingDialog#shown') {
        group = 'interactions';
      }
      if (type === 'duration' || comparator === '$before' || comparator === '$after') {
        value = Math.abs(value);
      }
      if (group === 'fs_state') {
        suffix = key;
      }
      let target;
      let interactionType;
      let survey_other = false;
      if (group === 'interactions' && suffix.includes('answers/')) {
        var _interactions$interac, _interactions$interac2;
        group = 'interaction_response_targeting';
        target = key;
        if (comparator === '$exists' && value === false) {
          comparator = '$notexists';
        }
        let option = interactions === null || interactions === void 0 ? void 0 : (_interactions$interac = interactions.interaction_response_targeting) === null || _interactions$interac === void 0 ? void 0 : (_interactions$interac2 = _interactions$interac.options) === null || _interactions$interac2 === void 0 ? void 0 : _interactions$interac2.find(opt => opt.key === target);
        if (option) {
          var _interactions$interac3, _interactions$interac4;
          key = option.interaction;
          const parent = interactions === null || interactions === void 0 ? void 0 : (_interactions$interac3 = interactions.interactions) === null || _interactions$interac3 === void 0 ? void 0 : (_interactions$interac4 = _interactions$interac3.options) === null || _interactions$interac4 === void 0 ? void 0 : _interactions$interac4.find(interaction => interaction.id === key);
          if (parent) {
            interactionType = parent.type;
          }
          type = getAttributeType(option.type, attributes);
          if (suffix === 'answers/value' && ['multiselect', 'multichoice'].includes(option.type)) {
            type = 'survey_question_text';
            survey_other = true;
          }
        } else {
          var _interactions$interac5, _interactions$interac6;
          option = interactions === null || interactions === void 0 ? void 0 : (_interactions$interac5 = interactions.interactions) === null || _interactions$interac5 === void 0 ? void 0 : (_interactions$interac6 = _interactions$interac5.options) === null || _interactions$interac6 === void 0 ? void 0 : _interactions$interac6.find(opt => opt.id === target);
          if (option) {
            interactionType = option.type;
            type = getAttributeType(option.type, attributes);
            target = value;
          } else {
            console.warn('Missing Interaction Response:', target);
            interactionType = 'MISSING';
            type = typeof value;
          }
        }
      }
      const id = gguid();
      const data = {
        id,
        group,
        key,
        target,
        suffix,
        type,
        value,
        comparator
      };
      if (['code_point', 'interactions', 'interaction_response_targeting', 'fs_state'].includes(group)) {
        delete data.value;
        delete data.comparator;
        delete data.suffix;
        const found = rules.find(r => r.group === group && r.key === key);
        if (group !== 'interaction_response_targeting') {
          delete data.target;
          type = getAttributeType(`${group}/${suffix}`, attributes);
        } else {
          data.interactionType = interactionType;
        }
        const sub_rule = {
          parent: found ? found.id : id,
          id: gguid(),
          type,
          survey_other,
          target,
          comparator,
          suffix,
          value,
          key
        };
        if (group === 'fs_state') {
          delete sub_rule.suffix;
        }
        if (found) {
          found.details.push(sub_rule);
          continue;
        }
        data.details = [sub_rule];
      }
      rules.push(data);
    }
  }
  return rules;
};
const checkValues = _ref2 => {
  let {
    criterium,
    interactions,
    attributes
  } = _ref2;
  const [type, value] = criterium;
  switch (type) {
    case '_version':
      {
        console.info('Version:', value);
        break;
      }
    case '$or':
      {
        return value.map(kid => Object.entries(kid).map(subCriterium => checkValues({
          criterium: subCriterium,
          interactions,
          attributes
        }))).flat();
      }
    case '$and':
      {
        const rules = consolidateRules({
          values: value,
          interactions,
          attributes
        });
        return {
          id: gguid(),
          type,
          rules
        };
      }
    default:
      {
        console.error('Skipping Unknown Group Type:', type, value);
      }
  }
};
const injestCriteria = _ref3 => {
  let {
    criteria,
    interactions,
    attributes
  } = _ref3;
  if (!criteria || Object.keys(criteria).length === 0) {
    return [];
  }
  let output = Object.entries(criteria).map(criterium => checkValues({
    criterium,
    interactions,
    attributes
  })).flat();
  output = output.filter(Boolean);
  return output;
};
const convertToCiteria = newCriteria => {
  if (newCriteria.length === 0) {
    return {};
  }
  const output = [];
  for (const segment of newCriteria) {
    const newSegment = [];
    if (segment.rules.length === 0) {
      continue;
    }
    for (const newRule of segment.rules) {
      const {
        comparator,
        details,
        key,
        type,
        value
      } = newRule;
      let {
        group
      } = newRule;
      if (group === 'interactions' && key && (key.startsWith('com.') || key.startsWith('local#'))) {
        group = 'code_point';
      }
      if (['code_point', 'interaction_response_targeting', 'bulk-upload'].includes(group) && Array.isArray(details) && details.length === 0) {
        continue;
      }
      if (Array.isArray(details) && details.length > 0) {
        for (const detail of details) {
          const {
            group: detailGroup,
            key: detailKey,
            type: detailType
          } = detail;
          let {
            comparator: detailComparator,
            value: detailValue
          } = detail;
          if (detailComparator === '$notexists') {
            detailComparator = '$exists';
          }
          const detailRule = {};
          if (group === 'bulk-upload' && Array.isArray(detailValue)) {
            if (!detail.key || detail.value.length === 0) {
              continue;
            }
            detailRule.$or = detailValue.map(subValue => {
              if (detailType === 'version') {
                return {
                  [`${detailGroup}/${detailKey}`]: {
                    [detailComparator]: {
                      _type: 'version',
                      version: subValue
                    }
                  }
                };
              }
              return {
                [`${detailGroup}/${detailKey}`]: {
                  [detailComparator]: subValue
                }
              };
            });
            newSegment.push(detailRule);
            continue;
          }
          if (group === 'fs_state') {
            detailRule[`${group}/${newRule.key}`] = {
              [detailComparator]: detailValue
            };
            newSegment.push(detailRule);
            continue;
          }
          if (group === 'interaction_response_targeting') {
            if (!detail.type || !detail.suffix || !detail.target || !detailComparator || detailValue === '' || detailValue === undefined) {
              continue;
            }
            if (detail.type === 'note_action') {
              detailRule[`interactions/${detail.key}/${detail.suffix}`] = {
                [detailComparator]: detailValue
              };
              newSegment.push(detailRule);
              continue;
            }
            if (detailComparator === '$notcontains') {
              newSegment.push({
                $not: [{
                  [`interactions/${detail.target}/${detail.suffix}`]: {
                    $contains: detailValue
                  }
                }]
              });
              continue;
            }
            detailRule[`interactions/${detail.target}/${detail.suffix}`] = {
              [detailComparator]: detailValue
            };
            newSegment.push(detailRule);
            continue;
          }
          if (!detail.type || !detail.suffix || !detailComparator || detailValue === '' || detailValue === undefined) {
            continue;
          }
          if (detail.suffix === 'last_invoked_at/total') {
            detailValue = Math.abs(detailValue) * -1;
          }
          if (detailComparator === '$notcontains') {
            detailRule[`${group}/${newRule.key || detail.key}/${detail.suffix}`] = {
              $not: [{
                $contains: detailValue
              }]
            };
            newSegment.push(detailRule);
            continue;
          }
          detailRule[`${group}/${newRule.key || detail.key}/${detail.suffix}`] = {
            [detailComparator]: detailValue
          };
          newSegment.push(detailRule);
        }
      } else {
        if (!key || !comparator || value === '' || value === undefined) {
          continue;
        }
        group = group ? `${group}/` : '';
        if (comparator === '$notcontains') {
          newSegment.push({
            $not: [{
              [`${group}${key}`]: {
                $contains: value
              }
            }]
          });
          continue;
        }
        if (type === 'version') {
          newSegment.push({
            [`${group}${key}`]: {
              [comparator]: {
                _type: 'version',
                version: value
              }
            }
          });
          continue;
        }
        if (type === 'datetime') {
          newSegment.push({
            [`${group}${key}`]: {
              [comparator]: {
                _type: 'datetime',
                sec: value
              }
            }
          });
          continue;
        }
        if (group === 'random/') {
          newSegment.push({
            [`${group}${key}/percent`]: {
              [comparator]: value
            }
          });
          continue;
        }
        newSegment.push({
          [`${group}${key}`]: {
            [comparator]: value
          }
        });
      }
    }
    if (newSegment.length) {
      output.push({
        [segment.type]: newSegment
      });
    }
  }
  if (output.length > 0) {
    return {
      $or: output
    };
  }
  return {};
};
const countRules = function () {
  let newCriteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let segment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  let rules = 0;
  if (!Array.isArray(newCriteria)) {
    return rules;
  }
  for (const rule of newCriteria) {
    if (segment && rule.id !== segment) {
      continue;
    }
    for (const subrule of rule.rules) {
      if (subrule.group === 'bulk-upload') {
        rules += subrule.details[0].value.length;
      } else if (['fs_state', 'code_point', 'interactions', 'interaction_response_targeting'].includes(subrule.group)) {
        rules += subrule.details.length;
      } else {
        rules++;
      }
    }
  }
  return rules;
};

const deepEqual = (foo, bar) => {
  let len;
  if (foo === bar) {
    return true;
  }
  if (foo && bar && foo.constructor === bar.constructor) {
    if (foo.constructor === Date) {
      return foo.getTime() === bar.getTime();
    }
    if (foo.constructor === RegExp) {
      return foo.toString() === bar.toString();
    }
    if (foo.constructor === Array) {
      len = foo.length;
      if (len === bar.length) {
        while (len-- && deepEqual(foo[len], bar[len]));
      }
      return len === -1;
    }
    if (!foo.constructor || typeof foo === 'object') {
      len = 0;
      for (const key in foo) {
        if (Object.prototype.hasOwnProperty.call(foo, key) && ++len && !Object.prototype.hasOwnProperty.call(bar, key)) {
          return false;
        }
        if (!(key in bar) || !deepEqual(foo[key], bar[key])) {
          return false;
        }
      }
      return Object.keys(bar).length === len;
    }
  }
  return foo !== foo && bar !== bar;
};
const useDeepCompareMemoize = dependencies => {
  const ref = React.useRef();
  const signalRef = React.useRef(0);
  if (!deepEqual(dependencies, ref.current)) {
    ref.current = dependencies;
    signalRef.current += 1;
  }
  return [signalRef.current];
};
const useDeepCompareEffect = (callback, dependencies) => React.useEffect(callback, useDeepCompareMemoize(dependencies));
var useDeepCompareEffect$1 = useDeepCompareEffect;

const comparators = {
  boolean: [{
    text: 'is',
    json: '{ "__FIELD__": { "$eq": __VALUE__ } }',
    class: 'is',
    value: '$eq'
  }, {
    text: 'is not',
    json: '{ "__FIELD__": { "$ne": __VALUE__ } }',
    class: 'ne',
    value: '$ne'
  }],
  string: [{
    text: 'is',
    json: '{ "__FIELD__": { "$eq": __VALUE__ } }',
    class: 'is',
    value: '$eq'
  }, {
    text: 'is not',
    json: '{ "__FIELD__": { "$ne": __VALUE__ } }',
    class: 'ne',
    value: '$ne'
  }, {
    text: 'begins with',
    json: '{ "__FIELD__": { "$starts_with": __VALUE__ } }',
    class: 'starts_with',
    value: '$starts_with'
  }, {
    text: 'ends with',
    json: '{ "__FIELD__": { "$ends_with": __VALUE__ } }',
    class: 'ends_with',
    value: '$ends_with'
  }, {
    text: 'contains',
    json: '{ "__FIELD__": { "$contains": __VALUE__ } }',
    class: 'contains',
    value: '$contains'
  }
  ],
  number: [{
    text: 'is',
    json: '{ "__FIELD__": { "$eq": __VALUE__ } }',
    class: 'is',
    value: '$eq'
  }, {
    text: 'is not',
    json: '{ "__FIELD__": { "$ne": __VALUE__ } }',
    class: 'ne',
    value: '$ne'
  }, {
    text: 'is less than',
    json: '{ "__FIELD__": { "$lt": __VALUE__ } }',
    class: 'lt',
    value: '$lt'
  }, {
    text: 'is more than',
    json: '{ "__FIELD__": { "$gt": __VALUE__ } }',
    class: 'gt',
    value: '$gt'
  }, {
    text: 'is at most',
    json: '{ "__FIELD__": { "$lte": __VALUE__ } }',
    class: 'lte',
    value: '$lte'
  }, {
    text: 'is at least',
    json: '{ "__FIELD__": { "$gte": __VALUE__ } }',
    class: 'gte',
    value: '$gte'
  }],
  duration: [{
    text: 'is more than',
    json: '{ "__FIELD__": { "$before": __VALUE__ } }',
    class: 'before',
    value: '$before'
  }, {
    text: 'is less than',
    json: '{ "__FIELD__": { "$after": __VALUE__ } }',
    class: 'after',
    value: '$after'
  }],
  datetime: [{
    text: 'is more than',
    json: '{ "__FIELD__": { "$before": __VALUE__ } }',
    class: 'before',
    value: '$before'
  }, {
    text: 'is less than',
    json: '{ "__FIELD__": { "$after": __VALUE__ } }',
    class: 'after',
    value: '$after'
  }, {
    text: 'is before',
    json: '{ "__FIELD__": { "$lte": { "_type": "datetime", "sec": __VALUE__ } } }',
    class: 'lte',
    value: '$lte'
  }, {
    text: 'is after',
    json: '{ "__FIELD__": { "$gte": { "_type": "datetime", "sec": __VALUE__ } } }',
    class: 'gte',
    value: '$gte'
  }],
  version: [{
    text: 'is',
    json: '{ "__FIELD__": { "$eq": { "_type": "version", "version": __VALUE__ } } }',
    class: 'is',
    value: '$eq'
  }, {
    text: 'is not',
    json: '{ "__FIELD__": { "$ne": { "_type": "version", "version": __VALUE__ } } }',
    class: 'ne',
    value: '$ne'
  }, {
    text: 'is less than',
    json: '{ "__FIELD__": { "$lt": { "_type": "version", "version": __VALUE__ } } }',
    class: 'lt',
    value: '$lt'
  }, {
    text: 'is more than',
    json: '{ "__FIELD__": { "$gt": { "_type": "version", "version": __VALUE__ } } }',
    class: 'gt',
    value: '$gt'
  }, {
    text: 'is at most',
    json: '{ "__FIELD__": { "$lte": { "_type": "version", "version": __VALUE__ } } }',
    class: 'lte',
    value: '$lte'
  }, {
    text: 'is at least',
    json: '{ "__FIELD__": { "$gte": { "_type": "version", "version": __VALUE__ } } }',
    class: 'gte',
    value: '$gte'
  }],
  survey_question: [{
    text: 'responded',
    json: '{ "__FIELD__": { "$exists": true } }',
    class: 'exists',
    value: '$exists'
  }, {
    text: 'didn\'t respond',
    json: '{ "__FIELD__": { "$exists": false } }',
    class: 'notexists',
    value: '$notexists'
  }, {
    text: 'answered',
    json: '{ "__FIELD__": { "$eq": __VALUE__ } }',
    class: 'is',
    value: '$eq'
  }, {
    text: 'didn\'t answer',
    json: '{ "__FIELD__": { "$ne": __VALUE__ } }',
    class: 'ne',
    value: '$ne'
  }],
  survey_question_text: [{
    text: 'responded',
    json: '{ "__FIELD__": { "$exists": true } }',
    class: 'exists',
    value: '$exists'
  }, {
    text: 'didn\'t respond',
    json: '{ "__FIELD__": { "$exists": false } }',
    class: 'notexists',
    value: '$notexists'
  }, {
    text: 'is',
    json: '{ "__FIELD__": { "$eq": __VALUE__ } }',
    class: 'is',
    value: '$eq'
  }, {
    text: 'is not',
    json: '{ "__FIELD__": { "$ne": __VALUE__ } }',
    class: 'ne',
    value: '$ne'
  }, {
    text: 'begins with',
    json: '{ "__FIELD__": { "$starts_with": __VALUE__ } }',
    class: 'starts_with',
    value: '$starts_with'
  }, {
    text: 'ends with',
    json: '{ "__FIELD__": { "$ends_with": __VALUE__ } }',
    class: 'ends_with',
    value: '$ends_with'
  }, {
    text: 'contains',
    json: '{ "__FIELD__": { "$contains": __VALUE__ } }',
    class: 'contains',
    value: '$contains'
  }, {
    text: 'does not contain',
    json: '{ "$not": { "__FIELD__": { "$contains": __VALUE__ } } }',
    class: 'does-not-contain',
    value: '$notcontains'
  }],
  survey_question_other_text: [{
    text: 'responded',
    json: '{ "__FIELD__": { "$exists": true } }',
    class: 'exists',
    value: '$exists'
  }, {
    text: 'didn\'t respond',
    json: '{ "__FIELD__": { "$exists": false } }',
    class: 'notexists',
    value: '$notexists'
  }, {
    text: 'is',
    json: '{ "__FIELD__": { "$eq": __VALUE__ } }',
    class: 'is',
    value: '$eq'
  }, {
    text: 'is not',
    json: '{ "__FIELD__": { "$ne": __VALUE__ } }',
    class: 'ne',
    value: '$ne'
  }, {
    text: 'begins with',
    json: '{ "__FIELD__": { "$starts_with": __VALUE__ } }',
    class: 'starts_with',
    value: '$starts_with'
  }, {
    text: 'ends with',
    json: '{ "__FIELD__": { "$ends_with": __VALUE__ } }',
    class: 'ends_with',
    value: '$ends_with'
  }, {
    text: 'contains',
    json: '{ "__FIELD__": { "$contains": __VALUE__ } }',
    class: 'contains',
    value: '$contains'
  }, {
    text: 'does not contain',
    json: '{ "$not": { "__FIELD__": { "$contains": __VALUE__ } } }',
    class: 'does-not-contain',
    value: '$notcontains'
  }],
  survey_question_number: [{
    text: 'responded',
    json: '{ "__FIELD__": { "$exists": true } }',
    class: 'exists',
    value: '$exists'
  }, {
    text: 'didn\'t respond',
    json: '{ "__FIELD__": { "$exists": false } }',
    class: 'notexists',
    value: '$notexists'
  }, {
    text: 'is',
    json: '{ "__FIELD__": { "$eq": __VALUE__ } }',
    class: 'is',
    value: '$eq'
  }, {
    text: 'is not',
    json: '{ "__FIELD__": { "$ne": __VALUE__ } }',
    class: 'ne',
    value: '$ne'
  }, {
    text: 'is less than',
    json: '{ "__FIELD__": { "$lt": __VALUE__ } }',
    class: 'lt',
    value: '$lt'
  }, {
    text: 'is more than',
    json: '{ "__FIELD__": { "$gt": __VALUE__ } }',
    class: 'gt',
    value: '$gt'
  }, {
    text: 'is at most',
    json: '{ "__FIELD__": { "$lte": __VALUE__ } }',
    class: 'lte',
    value: '$lte'
  }, {
    text: 'is at least',
    json: '{ "__FIELD__": { "$gte": __VALUE__ } }',
    class: 'gte',
    value: '$gte'
  }],
  note_action: [{
    text: 'selected',
    json: '{ "__FIELD__": { "$eq": __VALUE__ } }',
    class: 'is',
    value: '$eq'
  }, {
    text: 'didn\'t select',
    json: '{ "__FIELD__": { "$ne": __VALUE__ } }',
    class: 'ne',
    value: '$ne'
  }]
};
var defaultComparators = comparators;

const defaultRules = [{
  group: 'Fan Signals',
  value: 'Fan',
  label: 'New Fan',
  className: 'fan',
  platform: ['android', 'ios'],
  type: 'fan_signal'
}, {
  group: 'Fan Signals',
  value: 'ReclaimedFan',
  label: 'Shifted to Fan',
  className: 'reclaimed-fan',
  platform: ['android', 'ios'],
  type: 'fan_signal'
}, {
  group: 'Fan Signals',
  value: 'RepeatFan',
  label: 'Repeat Fan',
  className: 'repeat-fan',
  platform: ['android', 'ios'],
  type: 'fan_signal'
}, {
  group: 'Fan Signals',
  value: 'Opportunity',
  label: 'New Risk',
  className: 'opportunity',
  platform: ['android', 'ios'],
  type: 'fan_signal'
}, {
  group: 'Fan Signals',
  value: 'LostFan',
  label: 'Shifted to Risk',
  className: 'lost-fan',
  platform: ['android', 'ios'],
  type: 'fan_signal'
}, {
  group: 'Fan Signals',
  value: 'RepeatOpportunity',
  label: 'Repeat Risk',
  className: 'repeat-opportunity',
  platform: ['android', 'ios'],
  type: 'fan_signal'
},
{
  group: 'Events',
  label: 'Has Seen Event',
  value: 'code_point',
  className: 'code-point',
  type: 'parent'
}, {
  group: 'Interactions',
  label: 'Has Seen Interaction',
  value: 'interactions',
  className: 'interaction',
  type: 'parent'
},
{
  group: 'Interactions',
  label: 'Has Responded to Interaction',
  value: 'interaction_response_targeting',
  className: 'interaction_response_targeting',
  type: 'parent'
}, {
  group: 'Random Sampling',
  label: 'Percent of customers',
  value: 'random',
  className: 'random-sampling',
  type: 'number'
}, {
  group: 'Person & Device Data',
  label: 'Carrier',
  value: 'device/carrier',
  className: 'carrier',
  platform: ['android', 'ios'],
  type: 'string'
},
{
  group: 'Person & Device Data',
  label: 'Country',
  value: 'device/locale_country_code',
  className: 'country',
  platform: ['android', 'ios'],
  type: 'string'
}, {
  group: 'Person & Device Data',
  label: 'Language',
  value: 'device/locale_language_code',
  className: 'language',
  type: 'string'
}, {
  group: 'Person & Device Data',
  label: 'Device Model',
  value: 'device/model',
  className: 'model',
  platform: ['android'],
  type: 'string'
}, {
  group: 'Person & Device Data',
  label: 'Device',
  value: 'device/hardware',
  className: 'hardware',
  platform: ['ios'],
  type: 'string'
}, {
  group: 'Person & Device Data',
  label: 'OS Version',
  value: 'device/os_version',
  className: 'os-version',
  platform: ['android', 'ios'],
  type: 'version'
},
{
  group: 'Person & Device Data',
  label: 'User Agent',
  value: 'device/user_agent',
  className: 'user-agent web',
  platform: ['web'],
  type: 'string'
}, {
  group: 'Person & Device Data',
  label: 'App Version',
  value: 'application/version',
  className: 'application-version web',
  platform: ['web'],
  type: 'version'
},
{
  group: 'Person & Device Data',
  label: 'App Version',
  value: 'application/cf_bundle_short_version_string',
  className: 'application-version ios',
  platform: ['ios'],
  type: 'version'
},
{
  group: 'Person & Device Data',
  label: 'App Version Code',
  value: 'application/version_code',
  className: 'application-version android',
  platform: ['android'],
  type: 'number'
}, {
  group: 'Person & Device Data',
  label: 'App Version Name',
  value: 'application/version_name',
  className: 'application-version android',
  platform: ['android'],
  type: 'version'
}, {
  group: 'Person & Device Data',
  label: 'App Build Type',
  value: 'application/debug',
  className: 'debug',
  type: 'boolean'
}];
var defaultRules$1 = defaultRules;

const renderMenuItemChildren = option => {
  if (!option || !option.title || !option.value) {
    return null;
  }
  return React__default["default"].createElement("span", {
    className: "title"
  }, option.title);
};
const defaultLabelKeyAsync = option => (option === null || option === void 0 ? void 0 : option.value) || '(no label)';
const ApptentiveTypeahead = function ApptentiveTypeahead(_ref) {
  let {
    async = true,
    defaultOptions = [],
    fetchAttributes = () => {},
    labelKeyAsync = defaultLabelKeyAsync,
    onBlur = () => {},
    onTypeaheadInput = () => {},
    rule = {},
    ruleKey = 'value',
    defaultInputValue = rule[ruleKey],
    placeholder = 'Type to search...',
    isInvalid = false
  } = _ref;
  const [isLoading, setIsLoading] = React.useState(false);
  const [options, setOptions] = React.useState(defaultOptions);
  const handleSelect = React.useCallback(option => {
    if (Array.isArray(option) && option.length > 0 && option[0].value) {
      onTypeaheadInput(option[0].value);
    }
  }, [onTypeaheadInput]);
  const handleSearch = React.useCallback(async query => {
    setIsLoading(true);
    try {
      const newOptions = await fetchAttributes({
        rule,
        query
      });
      if (Array.isArray(newOptions)) {
        const unique = [...new Map([...defaultOptions, ...newOptions].map(item => [item.value, item])).values()];
        setOptions(_oldOptions => unique);
      } else {
        console.error('fetchAttributes returned something other than an array:', newOptions);
      }
    } catch (error) {
      console.error('Typeahead fetchAttributes Error:', error);
    }
    setIsLoading(false);
  }, []);
  let defaultSelected = options.find(i => i.value === `${defaultInputValue}`);
  if (!defaultSelected && defaultInputValue) {
    defaultSelected = {
      title: `${defaultInputValue}`,
      value: `${defaultInputValue}`
    };
  }
  if (!async) {
    return React__default["default"].createElement("div", {
      className: "typeahead"
    }, React__default["default"].createElement(reactBootstrapTypeahead.Typeahead, {
      selected: defaultSelected ? [defaultSelected] : [],
      filterBy: ['title', 'value'],
      id: rule.id,
      isLoading: isLoading,
      labelKey: "title",
      minLength: 0,
      onInputChange: onTypeaheadInput,
      onChange: handleSelect,
      onBlur: onBlur,
      options: options,
      placeholder: placeholder,
      renderMenuItemChildren: renderMenuItemChildren,
      isInvalid: isInvalid
    }));
  }
  return React__default["default"].createElement("div", {
    className: "typeahead"
  }, React__default["default"].createElement(reactBootstrapTypeahead.AsyncTypeahead, {
    selected: defaultSelected ? [defaultSelected] : [],
    filterBy: ['title', 'value'],
    id: rule.id,
    isLoading: isLoading,
    labelKey: labelKeyAsync,
    minLength: 0,
    onInputChange: onTypeaheadInput,
    onChange: handleSelect,
    onSearch: handleSearch,
    onBlur: onBlur,
    options: options,
    placeholder: placeholder,
    renderMenuItemChildren: renderMenuItemChildren,
    isInvalid: isInvalid
  }));
};
var ApptentiveTypeahead$1 = ApptentiveTypeahead;

const removeIcon = React__namespace.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 12 11"
}, React__namespace.createElement("g", {
  fill: "currentColor"
}, React__namespace.createElement("path", {
  d: "M2.11.904l8.486 8.485-.707.707-8.485-8.485z"
}), React__namespace.createElement("path", {
  d: "M9.89.904L1.403 9.389l.707.707 8.485-8.485z"
})));
var removeIcon$1 = removeIcon;

const updateErrors = (rule, message) => function () {
  let errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  const errorIndex = errors.findIndex(e => e.id === rule.id);
  const newErrors = [...errors];
  if (!message) {
    if (errorIndex !== -1) {
      newErrors.splice(errorIndex, 1);
    }
    return newErrors;
  }
  const newError = {
    id: rule.id,
    message
  };
  if (errorIndex === -1) {
    return [...errors, newError];
  }
  newErrors.splice(errorIndex, 1, newError);
  return newErrors;
};
const validateRule = (rule, setErrors) => {
  let message = '';
  if (!(rule !== null && rule !== void 0 && rule.key) && (rule === null || rule === void 0 ? void 0 : rule.group) !== 'bulk-upload' || (rule === null || rule === void 0 ? void 0 : rule.group) === 'bulk-upload' && rule !== null && rule !== void 0 && rule.details && !rule.details[0].key) {
    message = 'This field is required.';
  }
  if (message) {
    setErrors(updateErrors(rule, message));
  }
};
const validateDetails = (rule, setErrors) => {
  var _rule$details, _rule$details2, _rule$details$;
  let message = '';
  const checkDetails = rule === null || rule === void 0 ? void 0 : (_rule$details = rule.details) === null || _rule$details === void 0 ? void 0 : _rule$details.some(detail => !detail.target || !detail.comparator);
  if ((rule === null || rule === void 0 ? void 0 : (_rule$details2 = rule.details) === null || _rule$details2 === void 0 ? void 0 : _rule$details2.length) === 0 || rule.group === 'interaction_response_targeting' && checkDetails) {
    message = 'Details are required.';
  }
  if ((rule === null || rule === void 0 ? void 0 : rule.group) === 'bulk-upload' && rule !== null && rule !== void 0 && (_rule$details$ = rule.details[0]) !== null && _rule$details$ !== void 0 && _rule$details$.value && rule.details[0].value.length < 1) {
    message = ' ';
  }
  setErrors(updateErrors(rule, message));
};
const validateField$1 = (rule, setErrors) => event => {
  var _rule$details3, _event$target;
  let message = '';
  if ((rule === null || rule === void 0 ? void 0 : (_rule$details3 = rule.details) === null || _rule$details3 === void 0 ? void 0 : _rule$details3.length) === 0) {
    message = 'Details are required.';
  }
  if (!(event !== null && event !== void 0 && (_event$target = event.target) !== null && _event$target !== void 0 && _event$target.value)) {
    message = 'This field is required.';
  }
  setErrors(updateErrors(rule, message));
};
const getError = function (rule) {
  let errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!(rule !== null && rule !== void 0 && rule.id)) {
    console.error('Rule or ID is missing.');
    return undefined;
  }
  if (!Array.isArray(errors)) {
    console.error('Errors is not an array.');
    return undefined;
  }
  return errors.find(e => e.id === (rule === null || rule === void 0 ? void 0 : rule.id));
};
const updateCriteriaRule = (data, criteria, segment_id, targetRule, setErrors) => {
  const copyCriteria = [...criteria];
  const segment_index = copyCriteria.findIndex(s => s.id === segment_id);
  const segment = copyCriteria[segment_index];
  let rule_index;
  let newRule;
  let rule;
  if (targetRule.parent) {
    rule_index = segment.rules.findIndex(r => r.id === targetRule.parent);
    if (rule_index === -1) {
      console.error('Parent Rule Not Found:', targetRule.parent);
      return criteria;
    }
    rule = segment.rules[rule_index];
    const detail_index = rule.details.findIndex(d => d.id === targetRule.id);
    const detail = rule.details[detail_index];
    const newDetail = { ...detail,
      ...data
    };
    rule.details.splice(detail_index, 1, newDetail);
    newRule = { ...rule,
      details: rule.details
    };
  } else {
    rule_index = segment.rules.findIndex(r => r.id === targetRule.id);
    rule = segment.rules[rule_index];
    newRule = { ...rule,
      ...data
    };
  }
  validateDetails(newRule, setErrors);
  segment.rules.splice(rule_index, 1, newRule);
  const newSegment = { ...segment,
    rules: segment.rules
  };
  copyCriteria.splice(segment_index, 1, newSegment);
  return copyCriteria;
};
const updateCriteria = (data, segment_id, targetRule, setCriteria, setErrors) => {
  setCriteria(criteria => updateCriteriaRule(data, criteria, segment_id, targetRule, setErrors));
};
const removeCriteriaRule = (criteria, segment_id, targetRule, setErrors) => {
  const copyCriteria = [...criteria];
  const segment_index = copyCriteria.findIndex(s => s.id === segment_id);
  const segment = copyCriteria[segment_index];
  let rule_index;
  let newRule;
  let newSegment;
  if (targetRule.parent) {
    rule_index = segment.rules.findIndex(r => r.id === targetRule.parent);
    const rule = segment.rules[rule_index];
    const detail_index = rule.details.findIndex(d => d.id === targetRule.id);
    rule.details.splice(detail_index, 1);
    newRule = { ...rule,
      details: rule.details
    };
    validateDetails(rule, setErrors);
    segment.rules.splice(rule_index, 1, newRule);
    newSegment = { ...segment,
      rules: segment.rules
    };
  } else {
    rule_index = segment.rules.findIndex(r => r.id === targetRule.id);
    segment.rules.splice(rule_index, 1);
    newSegment = { ...segment,
      rules: segment.rules
    };
  }
  copyCriteria.splice(segment_index, 1, newSegment);
  return copyCriteria;
};
const removeRule = _ref => {
  let {
    segment,
    rule,
    setCriteria,
    setErrors
  } = _ref;
  return _event => {
    var _rule$details4;
    const ids = [rule.id];
    if ((rule === null || rule === void 0 ? void 0 : (_rule$details4 = rule.details) === null || _rule$details4 === void 0 ? void 0 : _rule$details4.length) > 0) {
      ids.push(...rule.details.map(detail => detail.id));
    }
    setErrors(errors => errors.filter(error => !ids.includes(error.id)));
    setCriteria(criteria => removeCriteriaRule(criteria, segment, rule, setErrors));
  };
};

var iosVersion = [{value:"7.0"},{value:"7.0.1"},{value:"7.0.2"},{value:"7.0.3"},{value:"7.0.4"},{value:"7.0.5"},{value:"7.0.6"},{value:"7.1"},{value:"7.1.1"},{value:"7.1.2"},{value:"8.0"},{value:"8.0.2"},{value:"8.1"},{value:"8.1.1"},{value:"8.1.2"},{value:"8.1.3"},{value:"8.2"},{value:"8.3"},{value:"8.4.1"},{value:"8.4"},{value:"9.0"},{value:"9.0.1"},{value:"9.0.2"},{value:"9.1"},{value:"9.2"},{value:"9.2.1"},{value:"9.3"},{value:"9.3.1"},{value:"9.3.2"},{value:"9.3.3"},{value:"9.3.4"},{value:"9.3.5"},{value:"10.0"},{value:"10.0.1"},{value:"10.0.2"},{value:"10.0.3"},{value:"10.1"},{value:"10.2"},{value:"10.2.1"},{value:"10.3"},{value:"10.3.1"},{value:"10.3.2"},{value:"10.3.3"},{value:"10.3.4"},{value:"11.0"},{value:"11.0.1"},{value:"11.0.2"},{value:"11.0.3"},{value:"11.1"},{value:"11.1.1"},{value:"11.1.2"},{value:"11.2"},{value:"11.2.1"},{value:"11.2.2"},{value:"11.2.3"},{value:"11.2.4"},{value:"11.2.5"},{value:"11.2.6"},{value:"11.3"},{value:"11.3.1"},{value:"11.4"},{value:"11.4.1"},{value:"12.0"},{value:"12.0.1"},{value:"12.1"},{value:"12.1.1"},{value:"12.1.2"},{value:"12.1.3"},{value:"12.1.4"},{value:"12.2"},{value:"12.3"},{value:"12.3.1"},{value:"12.3.2"},{value:"12.4"},{value:"12.4.1"},{value:"12.4.2"},{value:"12.4.3"},{value:"12.4.4"},{value:"12.4.5"},{value:"12.4.6"},{value:"12.4.7"},{value:"12.4.8"},{value:"12.4.9"},{value:"12.5"},{value:"12.5.1"},{value:"12.5.2"},{value:"12.5.3"},{value:"13.0"},{value:"13.1"},{value:"13.1.1"},{value:"13.1.2"},{value:"13.1.3"},{value:"13.2"},{value:"13.2.1"},{value:"13.2.2"},{value:"13.2.3"},{value:"13.3"},{value:"13.3.1"},{value:"13.4"},{value:"13.4.1"},{value:"13.5"},{value:"13.5.1"},{value:"13.6"},{value:"13.6.1"},{value:"13.7"},{value:"14.0"},{value:"14.0.1"},{value:"14.1"},{value:"14.2"},{value:"14.2.1"},{value:"14.3"},{value:"14.4"},{value:"14.4.1"},{value:"14.4.2"},{value:"14.5"},{value:"14.5.1"},{value:"14.6"},{value:"14.7"},{value:"14.7.1"},{value:"14.8"},{value:"14.8.1"},{value:"15.0"},{value:"15.0.1"},{value:"15.0.2"},{value:"15.1"},{value:"15.1.1"},{value:"15.2"}];

var androidVersion = [{value:"3.0"},{value:"3.1"},{value:"3.2"},{value:"3.2.1"},{value:"3.2.2"},{value:"3.2.3"},{value:"3.2.4"},{value:"3.2.5"},{value:"3.2.6"},{value:"4.0"},{value:"4.0.1"},{value:"4.0.2"},{value:"4.0.3"},{value:"4.0.4"},{value:"4.1"},{value:"4.1.1"},{value:"4.1.2"},{value:"4.2"},{value:"4.2.1"},{value:"4.2.2"},{value:"4.3"},{value:"4.3.1"},{value:"4.4"},{value:"4.4.1"},{value:"4.4.2"},{value:"4.4.3"},{value:"4.4.4"},{value:"5.0"},{value:"5.0.1"},{value:"5.0.2"},{value:"5.1"},{value:"5.1.1"},{value:"6.0"},{value:"6.0.1"},{value:"7.0"},{value:"7.1"},{value:"7.1.1"},{value:"7.1.2"},{value:"8.0"},{value:"8.1.0"},{value:"9"},{value:"10"},{value:"11"},{value:"12"}];

var locale_language_code = [{value:"aa",title:"Afar"},{value:"ab",title:"Abkhaz"},{value:"ae",title:"Avestan"},{value:"af",title:"Afrikaans"},{value:"ak",title:"Akan"},{value:"am",title:"Amharic"},{value:"an",title:"Aragonese"},{value:"ar",title:"Arabic"},{value:"ar-ae",title:"Arabic (United Arab Emirates)"},{value:"ar-bh",title:"Arabic (Bahrain)"},{value:"ar-dz",title:"Arabic (Algeria)"},{value:"ar-eg",title:"Arabic (Egypt)"},{value:"ar-iq",title:"Arabic (Iraq)"},{value:"ar-jo",title:"Arabic (Jordan)"},{value:"ar-kw",title:"Arabic (Kuwait)"},{value:"ar-lb",title:"Arabic (Lebanon)"},{value:"ar-ly",title:"Arabic (Libya)"},{value:"ar-ma",title:"Arabic (Morocco)"},{value:"ar-om",title:"Arabic (Oman)"},{value:"ar-qa",title:"Arabic (Qatar)"},{value:"ar-sa",title:"Arabic (Saudi Arabia)"},{value:"ar-sd",title:"Arabic (Sudan)"},{value:"ar-sy",title:"Arabic (Syria)"},{value:"ar-tn",title:"Arabic (Tunisia)"},{value:"ar-ye",title:"Arabic (Yemen)"},{value:"as",title:"Assamese"},{value:"av",title:"Avaric"},{value:"ay",title:"Aymara"},{value:"az",title:"Azerbaijani"},{value:"ba",title:"Bashkir"},{value:"be",title:"Belarusian"},{value:"be-by",title:"Belarusian (Belarus)"},{value:"bg",title:"Bulgarian"},{value:"bg-bg",title:"Bulgarian (Bulgaria)"},{value:"bh",title:"Bihari"},{value:"bi",title:"Bislama"},{value:"bm",title:"Bambara"},{value:"bn",title:"Bengali"},{value:"bo",title:"Tibetan Standard, Tibetan, Central"},{value:"br",title:"Breton"},{value:"bs",title:"Bosnian"},{value:"ca",title:"Catalan; Valencian"},{value:"ca-es",title:"Catalan (Spain)"},{value:"ce",title:"Chechen"},{value:"ch",title:"Chamorro"},{value:"co",title:"Corsican"},{value:"cr",title:"Cree"},{value:"cs",title:"Czech"},{value:"cs-cz",title:"Czech (Czech Republic)"},{value:"cu",title:"Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic"},{value:"cv",title:"Chuvash"},{value:"cy",title:"Welsh"},{value:"da",title:"Danish"},{value:"da-dk",title:"Danish (Denmark)"},{value:"de",title:"German"},{value:"de-at",title:"German (Austria)"},{value:"de-ch",title:"German (Switzerland)"},{value:"de-de",title:"German (Germany)"},{value:"de-lu",title:"German (Luxembourg)"},{value:"dv",title:"Divehi; Dhivehi; Maldivian;"},{value:"ee",title:"Ewe"},{value:"el",title:"Greek, Modern"},{value:"el-cy",title:"Greek (Cyprus)"},{value:"el-gr",title:"Greek (Greece)"},{value:"en",title:"English"},{value:"en-au",title:"English (Australia)"},{value:"en-ca",title:"English (Canada)"},{value:"en-gb",title:"English (United Kingdom)"},{value:"en-ie",title:"English (Ireland)"},{value:"en-in",title:"English (India)"},{value:"en-mt",title:"English (Malta)"},{value:"en-nz",title:"English (New Zealand)"},{value:"en-ph",title:"English (Philippines)"},{value:"en-sg",title:"English (Singapore)"},{value:"en-us",title:"English (United States)"},{value:"en-za",title:"English (South Africa)"},{value:"eo",title:"Esperanto"},{value:"es",title:"Spanish; Castilian"},{value:"es-ar",title:"Spanish (Argentina)"},{value:"es-bo",title:"Spanish (Bolivia)"},{value:"es-cl",title:"Spanish (Chile)"},{value:"es-co",title:"Spanish (Colombia)"},{value:"es-cr",title:"Spanish (Costa Rica)"},{value:"es-do",title:"Spanish (Dominican Republic)"},{value:"es-ec",title:"Spanish (Ecuador)"},{value:"es-es",title:"Spanish (Spain)"},{value:"es-gt",title:"Spanish (Guatemala)"},{value:"es-hn",title:"Spanish (Honduras)"},{value:"es-mx",title:"Spanish (Mexico)"},{value:"es-ni",title:"Spanish (Nicaragua)"},{value:"es-pa",title:"Spanish (Panama)"},{value:"es-pe",title:"Spanish (Peru)"},{value:"es-pr",title:"Spanish (Puerto Rico)"},{value:"es-py",title:"Spanish (Paraguay)"},{value:"es-sv",title:"Spanish (El Salvador)"},{value:"es-us",title:"Spanish (United States)"},{value:"es-uy",title:"Spanish (Uruguay)"},{value:"es-ve",title:"Spanish (Venezuela)"},{value:"et",title:"Estonian"},{value:"et-ee",title:"Estonian (Estonia)"},{value:"eu",title:"Basque"},{value:"fa",title:"Persian"},{value:"ff",title:"Fula; Fulah; Pulaar; Pular"},{value:"fi",title:"Finnish"},{value:"fi-fi",title:"Finnish (Finland)"},{value:"fj",title:"Fijian"},{value:"fo",title:"Faroese"},{value:"fr",title:"French"},{value:"fr-be",title:"French (Belgium)"},{value:"fr-ca",title:"French (Canada)"},{value:"fr-ch",title:"French (Switzerland)"},{value:"fr-fr",title:"French (France)"},{value:"fr-lu",title:"French (Luxembourg)"},{value:"fy",title:"Western Frisian"},{value:"ga",title:"Irish"},{value:"ga-ie",title:"Irish (Ireland)"},{value:"gd",title:"Scottish Gaelic; Gaelic"},{value:"gl",title:"Galician"},{value:"gn",title:"Guaraní"},{value:"gu",title:"Gujarati"},{value:"gv",title:"Manx"},{value:"ha",title:"Hausa"},{value:"he",title:"Hebrew (modern)"},{value:"hi",title:"Hindi"},{value:"hi-in",title:"Hindi (India)"},{value:"ho",title:"Hiri Motu"},{value:"hr",title:"Croatian"},{value:"hr-hr",title:"Croatian (Croatia)"},{value:"ht",title:"Haitian; Haitian Creole"},{value:"hu",title:"Hungarian"},{value:"hu-hu",title:"Hungarian (Hungary)"},{value:"hy",title:"Armenian"},{value:"hz",title:"Herero"},{value:"ia",title:"Interlingua"},{value:"id",title:"Indonesian"},{value:"ie",title:"Interlingue"},{value:"ig",title:"Igbo"},{value:"ii",title:"Nuosu"},{value:"ik",title:"Inupiaq"},{value:"in",title:"Indonesian"},{value:"in-id",title:"Indonesian (Indonesia)"},{value:"io",title:"Ido"},{value:"is",title:"Icelandic"},{value:"is-is",title:"Icelandic (Iceland)"},{value:"it",title:"Italian"},{value:"it-ch",title:"Italian (Switzerland)"},{value:"it-it",title:"Italian (Italy)"},{value:"iu",title:"Inuktitut"},{value:"iw",title:"Hebrew"},{value:"iw-il",title:"Hebrew (Israel)"},{value:"ja",title:"Japanese"},{value:"ja-jp",title:"Japanese (Japan)"},{value:"jv",title:"Javanese"},{value:"ka",title:"Georgian"},{value:"kg",title:"Kongo"},{value:"ki",title:"Kikuyu, Gikuyu"},{value:"kj",title:"Kwanyama, Kuanyama"},{value:"kk",title:"Kazakh"},{value:"kl",title:"Kalaallisut, Greenlandic"},{value:"km",title:"Khmer"},{value:"kn",title:"Kannada"},{value:"ko",title:"Korean"},{value:"ko-kr",title:"Korean (South Korea)"},{value:"kr",title:"Kanuri"},{value:"ks",title:"Kashmiri"},{value:"ku",title:"Kurdish"},{value:"kv",title:"Komi"},{value:"kw",title:"Cornish"},{value:"ky",title:"Kirghiz, Kyrgyz"},{value:"la",title:"Latin"},{value:"lb",title:"Luxembourgish, Letzeburgesch"},{value:"lg",title:"Luganda"},{value:"li",title:"Limburgish, Limburgan, Limburger"},{value:"ln",title:"Lingala"},{value:"lo",title:"Lao"},{value:"lt",title:"Lithuanian"},{value:"lt-lt",title:"Lithuanian (Lithuania)"},{value:"lu",title:"Luba-Katanga"},{value:"lv",title:"Latvian"},{value:"lv-lv",title:"Latvian (Latvia)"},{value:"mg",title:"Malagasy"},{value:"mh",title:"Marshallese"},{value:"mi",title:"Māori"},{value:"mk",title:"Macedonian"},{value:"mk-mk",title:"Macedonian (Macedonia)"},{value:"ml",title:"Malayalam"},{value:"mn",title:"Mongolian"},{value:"mr",title:"Marathi (Marāṭhī)"},{value:"ms",title:"Malay"},{value:"ms-my",title:"Malay (Malaysia)"},{value:"mt",title:"Maltese"},{value:"mt-mt",title:"Maltese (Malta)"},{value:"my",title:"Burmese"},{value:"na",title:"Nauru"},{value:"nb",title:"Norwegian Bokmål"},{value:"nd",title:"North Ndebele"},{value:"ne",title:"Nepali"},{value:"ng",title:"Ndonga"},{value:"nl",title:"Dutch"},{value:"nl-be",title:"Dutch (Belgium)"},{value:"nl-nl",title:"Dutch (Netherlands)"},{value:"nn",title:"Norwegian Nynorsk"},{value:"no",title:"Norwegian"},{value:"no-no",title:"Norwegian (Norway)"},{value:"nr",title:"South Ndebele"},{value:"nv",title:"Navajo, Navaho"},{value:"ny",title:"Chichewa; Chewa; Nyanja"},{value:"oc",title:"Occitan"},{value:"oj",title:"Ojibwe, Ojibwa"},{value:"om",title:"Oromo"},{value:"or",title:"Oriya"},{value:"os",title:"Ossetian, Ossetic"},{value:"pa",title:"Panjabi, Punjabi"},{value:"pi",title:"Pāli"},{value:"pl",title:"Polish"},{value:"pl-pl",title:"Polish (Poland)"},{value:"ps",title:"Pashto, Pushto"},{value:"pt",title:"Portuguese"},{value:"pt-br",title:"Portuguese (Brazil)"},{value:"pt-pt",title:"Portuguese (Portugal)"},{value:"qu",title:"Quechua"},{value:"rm",title:"Romansh"},{value:"rn",title:"Kirundi"},{value:"ro",title:"Romanian, Moldavian, Moldovan"},{value:"ro-ro",title:"Romanian (Romania)"},{value:"ru",title:"Russian"},{value:"ru-ru",title:"Russian (Russia)"},{value:"rw",title:"Kinyarwanda"},{value:"sa",title:"Sanskrit (Saṁskṛta)"},{value:"sc",title:"Sardinian"},{value:"sd",title:"Sindhi"},{value:"se",title:"Northern Sami"},{value:"sg",title:"Sango"},{value:"si",title:"Sinhala, Sinhalese"},{value:"sk",title:"Slovak"},{value:"sk-sk",title:"Slovak (Slovakia)"},{value:"sl",title:"Slovene"},{value:"sl-si",title:"Slovenian (Slovenia)"},{value:"sm",title:"Samoan"},{value:"sn",title:"Shona"},{value:"so",title:"Somali"},{value:"sq",title:"Albanian"},{value:"sq-al",title:"Albanian (Albania)"},{value:"sr",title:"Serbian"},{value:"sr-ba",title:"Serbian (Bosnia and Herzegovina)"},{value:"sr-cs",title:"Serbian (Serbia and Montenegro)"},{value:"sr-me",title:"Serbian (Montenegro)"},{value:"sr-rs",title:"Serbian (Serbia)"},{value:"ss",title:"Swati"},{value:"st",title:"Southern Sotho"},{value:"su",title:"Sundanese"},{value:"sv",title:"Swedish"},{value:"sv-se",title:"Swedish (Sweden)"},{value:"sw",title:"Swahili"},{value:"ta",title:"Tamil"},{value:"te",title:"Telugu"},{value:"tg",title:"Tajik"},{value:"th",title:"Thai"},{value:"th-th",title:"Thai (Thailand)"},{value:"ti",title:"Tigrinya"},{value:"tk",title:"Turkmen"},{value:"tl",title:"Tagalog"},{value:"tn",title:"Tswana"},{value:"to",title:"Tonga (Tonga Islands)"},{value:"tr",title:"Turkish"},{value:"tr-tr",title:"Turkish (Turkey)"},{value:"ts",title:"Tsonga"},{value:"tt",title:"Tatar"},{value:"tw",title:"Twi"},{value:"ty",title:"Tahitian"},{value:"ug",title:"Uighur, Uyghur"},{value:"uk",title:"Ukrainian"},{value:"uk-ua",title:"Ukrainian (Ukraine)"},{value:"ur",title:"Urdu"},{value:"uz",title:"Uzbek"},{value:"ve",title:"Venda"},{value:"vi",title:"Vietnamese"},{value:"vi-vn",title:"Vietnamese (Vietnam)"},{value:"vo",title:"Volapük"},{value:"wa",title:"Walloon"},{value:"wo",title:"Wolof"},{value:"xh",title:"Xhosa"},{value:"yi",title:"Yiddish"},{value:"yo",title:"Yoruba"},{value:"za",title:"Zhuang, Chuang"},{value:"zh",title:"Chinese"},{value:"zh-cn",title:"Chinese (Simplified, China)"},{value:"zh-hk",title:"Chinese (Hong Kong)"},{value:"zh-sg",title:"Chinese (Singapore)"},{value:"zh-tw",title:"Chinese (Traditional, Taiwan)"}];

var locale_country_code = [{title:"Andorra",value:"AD"},{title:"United Arab Emirates",value:"AE"},{title:"Afghanistan",value:"AF"},{title:"Antigua and Barbuda",value:"AG"},{title:"Anguilla",value:"AI"},{title:"Albania",value:"AL"},{title:"Armenia",value:"AM"},{title:"Angola",value:"AO"},{title:"Antarctica",value:"AQ"},{title:"Argentina",value:"AR"},{title:"American Samoa",value:"AS"},{title:"Austria",value:"AT"},{title:"Australia",value:"AU"},{title:"Aruba",value:"AW"},{title:"Åland Islands",value:"AX"},{title:"Azerbaijan",value:"AZ"},{title:"Bosnia and Herzegovina",value:"BA"},{title:"Barbados",value:"BB"},{title:"Bangladesh",value:"BD"},{title:"Belgium",value:"BE"},{title:"Burkina Faso",value:"BF"},{title:"Bulgaria",value:"BG"},{title:"Bahrain",value:"BH"},{title:"Burundi",value:"BI"},{title:"Benin",value:"BJ"},{title:"Saint Barthélemy",value:"BL"},{title:"Bermuda",value:"BM"},{title:"Brunei Darussalam",value:"BN"},{title:"Bolivia, Plurinational State of",value:"BO"},{title:"Bonaire, Sint Eustatius and Saba",value:"BQ"},{title:"Brazil",value:"BR"},{title:"Bahamas",value:"BS"},{title:"Bhutan",value:"BT"},{title:"Bouvet Island",value:"BV"},{title:"Botswana",value:"BW"},{title:"Belarus",value:"BY"},{title:"Belize",value:"BZ"},{title:"Canada",value:"CA"},{title:"Cocos (Keeling) Islands",value:"CC"},{title:"Congo, the Democratic Republic of the",value:"CD"},{title:"Central African Republic",value:"CF"},{title:"Congo",value:"CG"},{title:"Switzerland",value:"CH"},{title:"Côte d'Ivoire",value:"CI"},{title:"Cook Islands",value:"CK"},{title:"Chile",value:"CL"},{title:"Cameroon",value:"CM"},{title:"China",value:"CN"},{title:"Colombia",value:"CO"},{title:"Costa Rica",value:"CR"},{title:"Cuba",value:"CU"},{title:"Cabo Verde",value:"CV"},{title:"Curaçao",value:"CW"},{title:"Christmas Island",value:"CX"},{title:"Cyprus",value:"CY"},{title:"Czech Republic",value:"CZ"},{title:"Germany",value:"DE"},{title:"Djibouti",value:"DJ"},{title:"Denmark",value:"DK"},{title:"Dominica",value:"DM"},{title:"Dominican Republic",value:"DO"},{title:"Algeria",value:"DZ"},{title:"Ecuador",value:"EC"},{title:"Estonia",value:"EE"},{title:"Egypt",value:"EG"},{title:"Western Sahara",value:"EH"},{title:"Eritrea",value:"ER"},{title:"Spain",value:"ES"},{title:"Ethiopia",value:"ET"},{title:"Finland",value:"FI"},{title:"Fiji",value:"FJ"},{title:"Falkland Islands (Malvinas)",value:"FK"},{title:"Micronesia, Federated States of",value:"FM"},{title:"Faroe Islands",value:"FO"},{title:"France",value:"FR"},{title:"Gabon",value:"GA"},{title:"United Kingdom of Great Britain and Northern Ireland",value:"GB"},{title:"Grenada",value:"GD"},{title:"Georgia",value:"GE"},{title:"French Guiana",value:"GF"},{title:"Guernsey",value:"GG"},{title:"Ghana",value:"GH"},{title:"Gibraltar",value:"GI"},{title:"Greenland",value:"GL"},{title:"Gambia",value:"GM"},{title:"Guinea",value:"GN"},{title:"Guadeloupe",value:"GP"},{title:"Equatorial Guinea",value:"GQ"},{title:"Greece",value:"GR"},{title:"South Georgia and the South Sandwich Islands",value:"GS"},{title:"Guatemala",value:"GT"},{title:"Guam",value:"GU"},{title:"Guinea-Bissau",value:"GW"},{title:"Guyana",value:"GY"},{title:"Hong Kong",value:"HK"},{title:"Heard Island and McDonald Islands",value:"HM"},{title:"Honduras",value:"HN"},{title:"Croatia",value:"HR"},{title:"Haiti",value:"HT"},{title:"Hungary",value:"HU"},{title:"Indonesia",value:"ID"},{title:"Ireland",value:"IE"},{title:"Israel",value:"IL"},{title:"Isle of Man",value:"IM"},{title:"India",value:"IN"},{title:"British Indian Ocean Territory",value:"IO"},{title:"Iraq",value:"IQ"},{title:"Iran, Islamic Republic of",value:"IR"},{title:"Iceland",value:"IS"},{title:"Italy",value:"IT"},{title:"Jersey",value:"JE"},{title:"Jamaica",value:"JM"},{title:"Jordan",value:"JO"},{title:"Japan",value:"JP"},{title:"Kenya",value:"KE"},{title:"Kyrgyzstan",value:"KG"},{title:"Cambodia",value:"KH"},{title:"Kiribati",value:"KI"},{title:"Comoros",value:"KM"},{title:"Saint Kitts and Nevis",value:"KN"},{title:"Korea, Democratic People's Republic of",value:"KP"},{title:"Korea, Republic of",value:"KR"},{title:"Kuwait",value:"KW"},{title:"Cayman Islands",value:"KY"},{title:"Kazakhstan",value:"KZ"},{title:"Lao People's Democratic Republic",value:"LA"},{title:"Lebanon",value:"LB"},{title:"Saint Lucia",value:"LC"},{title:"Liechtenstein",value:"LI"},{title:"Sri Lanka",value:"LK"},{title:"Liberia",value:"LR"},{title:"Lesotho",value:"LS"},{title:"Lithuania",value:"LT"},{title:"Luxembourg",value:"LU"},{title:"Latvia",value:"LV"},{title:"Libya",value:"LY"},{title:"Morocco",value:"MA"},{title:"Monaco",value:"MC"},{title:"Moldova, Republic of",value:"MD"},{title:"Montenegro",value:"ME"},{title:"Saint Martin (French part)",value:"MF"},{title:"Madagascar",value:"MG"},{title:"Marshall Islands",value:"MH"},{title:"Macedonia, the former Yugoslav Republic of",value:"MK"},{title:"Mali",value:"ML"},{title:"Myanmar",value:"MM"},{title:"Mongolia",value:"MN"},{title:"Macao",value:"MO"},{title:"Northern Mariana Islands",value:"MP"},{title:"Martinique",value:"MQ"},{title:"Mauritania",value:"MR"},{title:"Montserrat",value:"MS"},{title:"Malta",value:"MT"},{title:"Mauritius",value:"MU"},{title:"Maldives",value:"MV"},{title:"Malawi",value:"MW"},{title:"Mexico",value:"MX"},{title:"Malaysia",value:"MY"},{title:"Mozambique",value:"MZ"},{title:"Namibia",value:"NA"},{title:"New Caledonia",value:"NC"},{title:"Niger",value:"NE"},{title:"Norfolk Island",value:"NF"},{title:"Nigeria",value:"NG"},{title:"Nicaragua",value:"NI"},{title:"Netherlands",value:"NL"},{title:"Norway",value:"NO"},{title:"Nepal",value:"NP"},{title:"Nauru",value:"NR"},{title:"Niue",value:"NU"},{title:"New Zealand",value:"NZ"},{title:"Oman",value:"OM"},{title:"Panama",value:"PA"},{title:"Peru",value:"PE"},{title:"French Polynesia",value:"PF"},{title:"Papua New Guinea",value:"PG"},{title:"Philippines",value:"PH"},{title:"Pakistan",value:"PK"},{title:"Poland",value:"PL"},{title:"Saint Pierre and Miquelon",value:"PM"},{title:"Pitcairn",value:"PN"},{title:"Puerto Rico",value:"PR"},{title:"Palestine, State of",value:"PS"},{title:"Portugal",value:"PT"},{title:"Palau",value:"PW"},{title:"Paraguay",value:"PY"},{title:"Qatar",value:"QA"},{title:"Réunion",value:"RE"},{title:"Romania",value:"RO"},{title:"Serbia",value:"RS"},{title:"Russian Federation",value:"RU"},{title:"Rwanda",value:"RW"},{title:"Saudi Arabia",value:"SA"},{title:"Solomon Islands",value:"SB"},{title:"Seychelles",value:"SC"},{title:"Sudan",value:"SD"},{title:"Sweden",value:"SE"},{title:"Singapore",value:"SG"},{title:"Saint Helena, Ascension and Tristan da Cunha",value:"SH"},{title:"Slovenia",value:"SI"},{title:"Svalbard and Jan Mayen",value:"SJ"},{title:"Slovakia",value:"SK"},{title:"Sierra Leone",value:"SL"},{title:"San Marino",value:"SM"},{title:"Senegal",value:"SN"},{title:"Somalia",value:"SO"},{title:"Suriname",value:"SR"},{title:"South Sudan",value:"SS"},{title:"Sao Tome and Principe",value:"ST"},{title:"El Salvador",value:"SV"},{title:"Sint Maarten (Dutch part)",value:"SX"},{title:"Syrian Arab Republic",value:"SY"},{title:"Swaziland",value:"SZ"},{title:"Turks and Caicos Islands",value:"TC"},{title:"Chad",value:"TD"},{title:"French Southern Territories",value:"TF"},{title:"Togo",value:"TG"},{title:"Thailand",value:"TH"},{title:"Tajikistan",value:"TJ"},{title:"Tokelau",value:"TK"},{title:"Timor-Leste",value:"TL"},{title:"Turkmenistan",value:"TM"},{title:"Tunisia",value:"TN"},{title:"Tonga",value:"TO"},{title:"Turkey",value:"TR"},{title:"Trinidad and Tobago",value:"TT"},{title:"Tuvalu",value:"TV"},{title:"Taiwan, Province of China",value:"TW"},{title:"Tanzania, United Republic of",value:"TZ"},{title:"Ukraine",value:"UA"},{title:"Uganda",value:"UG"},{title:"United States Minor Outlying Islands",value:"UM"},{title:"United States of America",value:"US"},{title:"Uruguay",value:"UY"},{title:"Uzbekistan",value:"UZ"},{title:"Holy See",value:"VA"},{title:"Saint Vincent and the Grenadines",value:"VC"},{title:"Venezuela, Bolivarian Republic of",value:"VE"},{title:"Virgin Islands, British",value:"VG"},{title:"Virgin Islands, U.S.",value:"VI"},{title:"Viet Nam",value:"VN"},{title:"Vanuatu",value:"VU"},{title:"Wallis and Futuna",value:"WF"},{title:"Samoa",value:"WS"},{title:"Yemen",value:"YE"},{title:"Mayotte",value:"YT"},{title:"South Africa",value:"ZA"},{title:"Zambia",value:"ZM"},{title:"Zimbabwe",value:"ZW"}];

const questionIcon = React__namespace.createElement("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22"
}, React__namespace.createElement("defs", null, React__namespace.createElement("circle", {
  id: "a",
  cx: "11",
  cy: "11",
  r: "9"
}), React__namespace.createElement("mask", {
  id: "b",
  width: "18",
  height: "18",
  x: "0",
  y: "0",
  fill: "#fff",
  maskContentUnits: "userSpaceOnUse",
  maskUnits: "objectBoundingBox"
}, React__namespace.createElement("use", {
  xlinkHref: "#a"
}))), React__namespace.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React__namespace.createElement("circle", {
  cx: "11",
  cy: "11",
  r: "11",
  fill: "#FFF"
}), React__namespace.createElement("use", {
  fill: "#FFF",
  stroke: "#B5B5B5",
  strokeWidth: "3",
  mask: "url(#b)",
  xlinkHref: "#a"
}), React__namespace.createElement("text", {
  fill: "#B5B5B5",
  fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
  fontSize: "11",
  fontWeight: "bold"
}, React__namespace.createElement("tspan", {
  x: "8",
  y: "15"
}, "?"))));
var questionIcon$1 = questionIcon;

const InfoTooltip = function InfoTooltip(_ref) {
  let {
    children
  } = _ref;
  const [visible, setVisible] = React.useState(false);
  const [bottomOrTop, setBottomOrTop] = React.useState('top');
  const [leftOrRight, setLeftOrRight] = React.useState('left');
  const toggle = React.useCallback(() => {
    setVisible(v => !v);
  }, [setVisible]);
  const tooltipRef = React.useRef(null);
  React.useEffect(() => {
    const handleDocumentClick = event => {
      if (tooltipRef && tooltipRef.current && !tooltipRef.current.contains(event.target) && visible) {
        setVisible(false);
      }
    };
    const applyGravity = () => {
      if (tooltipRef && tooltipRef.current) {
        const tooltipRect = tooltipRef.current.getBoundingClientRect();
        const centerX = window.innerWidth / 2;
        const centerY = window.innerHeight / 2;
        const currentYPos = tooltipRect[bottomOrTop];
        const currentXPos = tooltipRect[leftOrRight];
        setBottomOrTop(currentYPos < centerY ? 'top' : 'bottom');
        setLeftOrRight(currentXPos < centerX ? 'left' : 'right');
      }
    };
    applyGravity();
    document.addEventListener('click', handleDocumentClick, false);
    window.addEventListener('resize', applyGravity);
    window.addEventListener('scroll', applyGravity);
    return function cleanup() {
      document.removeEventListener('click', handleDocumentClick, false);
      window.removeEventListener('resize', applyGravity);
      window.removeEventListener('scroll', applyGravity);
    };
  });
  const styles = {
    [bottomOrTop]: '10px',
    [leftOrRight]: '10px'
  };
  return React__default["default"].createElement("div", {
    className: "reasoning-tooltip-container"
  }, React__default["default"].createElement("button", {
    className: "reasoning-button question",
    onClick: toggle,
    type: "button"
  }, questionIcon$1), visible && React__default["default"].createElement("div", {
    ref: tooltipRef,
    className: "reasoning-tooltip-box",
    style: styles
  }, React__default["default"].createElement("div", {
    className: "reasoning-tooltip-content"
  }, children), React__default["default"].createElement("div", {
    className: "reasoning-tooltip-actions"
  }, React__default["default"].createElement("button", {
    className: "reasoning-button normalize close reasoning-tooltip-action",
    onClick: toggle,
    type: "button"
  }, "Close"))));
};
var InfoTooltip$1 = InfoTooltip;

const buildTooltip = (rule, platform) => {
  if (['cf_bundle_version', 'cf_bundle_short_version_string', 'version_code', 'version', 'version_name', 'build', 'build_number'].includes(rule.key)) {
    if (platform === 'Android') {
      return React__namespace.createElement(InfoTooltip$1, null, React__namespace.createElement("strong", null, "Version Name and Version Code"), React__namespace.createElement("p", null, "Version Name and Version Code can be found either in <manifest> or Gradle build files.", ' ', React__namespace.createElement("a", {
        href: "https://developer.android.com/studio/publish/versioning.html",
        rel: "external nofollow noopener noreferrer",
        target: "_blank"
      }, "Learn more.")));
    }
    if (platform === 'iOS') {
      return React__namespace.createElement(InfoTooltip$1, null, React__namespace.createElement("strong", null, "App Version"), React__namespace.createElement("p", null, "Note that the version number is saved with the key", ' ', React__namespace.createElement("b", null, "CFBundleShortVersionString"), ' ', "in the Info.plist.", ' ', React__namespace.createElement("a", {
        href: "https://developer.apple.com/library/archive/technotes/tn2420/_index.html#//apple_ref/doc/uid/DTS40016603-CH1-TWO_NAMING_CONVENTIONS_FOR_VERSION_NUMBERS_AND_BUILD_NUMBERS",
        rel: "external nofollow noopener noreferrer",
        target: "_blank"
      }, "Learn more.")));
    }
  }
  return null;
};
const buildPredicate$1 = _ref => {
  let {
    segment,
    rule,
    setCriteria,
    fetchAttributes,
    platform,
    errors,
    setErrors
  } = _ref;
  const onInput = event => {
    let value = event;
    if (typeof event === 'object') {
      value = event.target.type === 'number' ? Number.parseFloat(event.target.value) : event.target.value;
      if (Number.isNaN(value)) {
        value = undefined;
      }
    }
    if (rule.type === 'boolean') {
      value = event.target.value === 'true';
    }
    validateField$1(rule, setErrors)({
      target: {
        value
      }
    });
    updateCriteria({
      value
    }, segment, rule, setCriteria, setErrors);
  };
  const name = `input-${rule.id}`;
  const errorMessage = getError(rule, errors);
  let inputContainer = React__namespace.createElement("input", {
    name: name,
    key: name,
    className: classNames({
      'rule-predicate-input': true,
      text: true,
      'is-invalid': errorMessage
    }),
    required: true,
    type: "text",
    value: rule.value,
    onChange: onInput,
    onBlur: validateField$1(rule, setErrors)
  });
  if (rule.type === 'version') {
    inputContainer = React__namespace.createElement("input", {
      name: name,
      key: name,
      className: classNames({
        'rule-predicate-input': true,
        version: true,
        'is-invalid': errorMessage
      }),
      required: true,
      type: "text",
      defaultValue: rule.value,
      onKeyPress: versionOnly,
      onInput: onInput,
      onBlur: validateField$1(rule, setErrors),
      placeholder: "Examples: 15, 11.0, 14.5.1"
    });
    if (rule.key === 'os_version' && platform && ['ios', 'android'].includes(platform.toLowerCase())) {
      const onTypeaheadInput = value => {
        validateField$1(rule, setErrors)({
          target: {
            value
          }
        });
        updateCriteria({
          value
        }, segment, rule, setCriteria, setErrors);
      };
      const fetchFile = platform.toLowerCase() === 'ios' ? iosVersion : androidVersion;
      const defaultOptions = fetchFile.map(_ref2 => {
        let {
          value = ''
        } = _ref2;
        return {
          title: value,
          value
        };
      });
      inputContainer = React__namespace.createElement(ApptentiveTypeahead$1, {
        onBlur: validateField$1(rule, setErrors),
        onTypeaheadInput: onTypeaheadInput,
        rule: rule,
        defaultOptions: defaultOptions,
        async: false,
        placeholder: "Examples: 15, 11.0, 14.5.1",
        isInvalid: !!errorMessage
      });
    }
  }
  if (rule.type === 'number') {
    if (rule.key === 'version_code') {
      inputContainer = React__namespace.createElement("input", {
        name: name,
        key: name,
        className: classNames({
          'rule-predicate-input': true,
          numeric: true,
          integer: true,
          'is-invalid': errorMessage
        }),
        required: true,
        type: "number",
        step: "1",
        pattern: "\\[0-9]+",
        defaultValue: rule.value,
        onKeyPress: integerOnly,
        onInput: onInput,
        onBlur: validateField$1(rule, setErrors)
      });
    } else {
      inputContainer = React__namespace.createElement("input", {
        name: name,
        key: name,
        className: classNames({
          'rule-predicate-input': true,
          numeric: true,
          'is-invalid': errorMessage
        }),
        required: true,
        type: "number",
        step: "1",
        defaultValue: rule.value,
        onKeyPress: numericOnly,
        onInput: onInput,
        onBlur: validateField$1(rule, setErrors)
      });
    }
  }
  if (rule.type === 'boolean') {
    inputContainer = React__namespace.createElement("select", {
      name: name,
      key: name,
      className: "rule-predicate-input boolean",
      required: true,
      defaultValue: rule.value,
      onChange: onInput
    }, React__namespace.createElement("option", {
      value: "true"
    }, rule.key === 'debug' ? 'Debug' : 'True'), React__namespace.createElement("option", {
      value: "false"
    }, rule.key === 'debug' ? 'Release' : 'False'));
  }
  if (rule.type === 'duration') {
    const inputDuration = React__namespace.createRef();
    const selectDuration = React__namespace.createRef();
    const {
      value
    } = rule;
    const [input, drop] = parseDuration(value);
    const onDurationInput = _event => {
      const durationType = selectDuration.current.value;
      let durationValue = Number.parseInt(inputDuration.current.value, 10);
      if (Number.isNaN(durationValue)) {
        durationValue = 0;
      }
      const timeMultiple = {
        days: 24 * 60 * 60,
        hours: 60 * 60,
        minutes: 60,
        seconds: 1
      };
      const time = timeMultiple[durationType] ? timeMultiple[durationType] * durationValue : 0;
      validateField$1(rule, setErrors)({
        target: {
          value: time
        }
      });
      updateCriteria({
        value: time
      }, segment, rule, setCriteria, setErrors);
    };
    inputContainer = React__namespace.createElement("div", {
      className: "duration-input-container",
      key: `container-${name}`
    }, React__namespace.createElement("input", {
      name: name,
      key: name,
      className: classNames({
        'rule-predicate-input': true,
        duration: true,
        'is-invalid': errorMessage
      }),
      required: true,
      min: "0",
      step: "1",
      type: "number",
      defaultValue: input,
      ref: inputDuration,
      onKeyPress: versionOnly,
      onInput: onDurationInput,
      onBlur: validateField$1(rule, setErrors)
    }), React__namespace.createElement("select", {
      name: `select-${rule.id}`,
      key: `select-${rule.id}`,
      className: "select-duration",
      defaultValue: drop,
      ref: selectDuration,
      onChange: onDurationInput
    }, React__namespace.createElement("option", {
      value: "days"
    }, "days ago"), React__namespace.createElement("option", {
      value: "hours"
    }, "hours ago"), React__namespace.createElement("option", {
      value: "minutes"
    }, "minutes ago"), React__namespace.createElement("option", {
      value: "seconds"
    }, "seconds ago")));
  }
  if (['device', 'person'].includes(rule.group) && rule.type === 'string' && (rule.key.includes('custom_data') || ['carrier', 'model', 'hardware'].includes(rule.key))) {
    const onTypeaheadInput = value => {
      validateField$1(rule, setErrors)({
        target: {
          value
        }
      });
      updateCriteria({
        value
      }, segment, rule, setCriteria, setErrors);
    };
    inputContainer = React__namespace.createElement(ApptentiveTypeahead$1, {
      onBlur: validateField$1(rule, setErrors),
      fetchAttributes: fetchAttributes,
      onTypeaheadInput: onTypeaheadInput,
      rule: rule,
      ruleKey: "value",
      defaultOptions: [],
      async: true,
      isInvalid: !!errorMessage
    });
  }
  if (['locale_country_code', 'locale_language_code'].includes(rule.key)) {
    const onTypeaheadInput = value => {
      validateField$1(rule, setErrors)({
        target: {
          value
        }
      });
      updateCriteria({
        value
      }, segment, rule, setCriteria, setErrors);
    };
    const fetchFile = rule.key === 'locale_country_code' ? locale_country_code : locale_language_code;
    const defaultOptions = fetchFile.map(_ref3 => {
      let {
        title = '',
        value = ''
      } = _ref3;
      return {
        title,
        value
      };
    });
    inputContainer = React__namespace.createElement(ApptentiveTypeahead$1, {
      onBlur: validateField$1(rule, setErrors),
      onTypeaheadInput: onTypeaheadInput,
      rule: rule,
      defaultOptions: defaultOptions,
      async: false,
      isInvalid: !!errorMessage
    });
  }
  return inputContainer;
};
const buildComparator = _ref4 => {
  let {
    segment,
    rule,
    comparators,
    setCriteria,
    errors,
    setErrors
  } = _ref4;
  const onChange = event => {
    if (['$exists', '$notexists'].includes(event.target.value)) {
      const value = event.target.value === '$exists';
      validateField$1(rule, setErrors)({
        target: {
          value
        }
      });
      updateCriteria({
        comparator: event.target.value,
        value
      }, segment, rule, setCriteria, setErrors);
      return;
    }
    if (['$exists', '$notexists'].includes(rule.comparator)) {
      updateCriteria({
        comparator: event.target.value,
        value: ''
      }, segment, rule, setCriteria, setErrors);
      return;
    }
    validateField$1(rule, setErrors)(event);
    updateCriteria({
      comparator: event.target.value
    }, segment, rule, setCriteria, setErrors);
  };
  if (!comparators[rule.type]) {
    console.warn('No comparators for:', rule.type);
    return null;
  }
  const errorMessage = getError(rule, errors);
  const className = classNames({
    comparator: true,
    [`${rule.type}-type`]: true,
    'is-invalid': errorMessage && !rule.comparator
  });
  return React__namespace.createElement("select", {
    className: className,
    key: `comparator-${rule.id}`,
    defaultValue: rule.comparator,
    onChange: onChange,
    onBlur: validateField$1(rule, setErrors)
  }, React__namespace.createElement("option", {
    key: `comparator-${rule.id}-missing`,
    value: "",
    disabled: true
  }, "Select a comparison..."), comparators[rule.type].map(c => c && React__namespace.createElement("option", {
    key: `comparator-${rule.id}-${c.class}`,
    value: c.value
  }, c.text)));
};
const renderDetails = _ref5 => {
  let {
    segment,
    parent,
    rule,
    comparators,
    setCriteria,
    fetchAttributes,
    platform,
    errors,
    setErrors
  } = _ref5;
  if (!rule.type) {
    return null;
  }
  if (errors.length === 0) {
    validateRule(parent, setErrors);
  }
  const onChange = event => {
    const suffix = event.target.value;
    let type = 'number';
    if (suffix === 'last_invoked_at/total') {
      type = 'duration';
      updateCriteria({
        suffix,
        type,
        comparator: '$before',
        value: 1
      }, segment, rule, setCriteria, setErrors);
      validateField$1(rule, setErrors)(event);
      return;
    }
    validateField$1(rule, setErrors)(event);
    updateCriteria({
      suffix,
      type,
      comparator: '$eq',
      value: 1
    }, segment, rule, setCriteria, setErrors);
  };
  const errorMessage = getError(rule, errors);
  const suffixClassName = classNames({
    'detail-type': true,
    'is-invalid': errorMessage && !rule.suffix
  });
  return React__namespace.createElement("div", {
    className: "segment-rule detail-sub-rule",
    key: `details-${rule.id}`
  }, React__namespace.createElement("div", {
    className: "segment-rule"
  }, React__namespace.createElement("div", {
    className: "select-option sub-rule-event-data"
  }, React__namespace.createElement("select", {
    className: suffixClassName,
    defaultValue: rule.suffix,
    onChange: onChange,
    onBlur: validateField$1(rule, setErrors)
  }, React__namespace.createElement("option", {
    key: `${rule.id}-missing`,
    value: "",
    disabled: true
  }, "Choose a rule..."), React__namespace.createElement("option", {
    key: `${rule.id}-invokes/total`,
    value: "invokes/total"
  }, "Count"), rule.suffix === 'invokes/build' && React__namespace.createElement("option", {
    key: `${rule.id}-invokes/build`,
    value: "invokes/build"
  }, "Count in installed build"), rule.suffix === 'invokes/build_number' && React__namespace.createElement("option", {
    key: `${rule.id}-invokes/build_number`,
    value: "invokes/build_number"
  }, "Count in installed build_number"), rule.suffix === 'invokes/cf_bundle_short_version_string' && React__namespace.createElement("option", {
    key: `${rule.id}-invokes/cf_bundle_short_version_string`,
    value: "invokes/cf_bundle_short_version_string"
  }, "Count in installed cf_bundle_short_version_string"), rule.suffix === 'invokes/version_name' && React__namespace.createElement("option", {
    key: `${rule.id}-invokes/version_name`,
    value: "invokes/version_name"
  }, "Count in installed version_name"), (rule.suffix === 'invokes/version_code' || platform.toLowerCase() === 'android') && React__namespace.createElement("option", {
    key: `${rule.id}-invokes/version_code`,
    value: "invokes/version_code"
  }, "Count in installed version"), (rule.suffix === 'invokes/cf_bundle_version' || platform.toLowerCase() === 'ios') && React__namespace.createElement("option", {
    key: `${rule.id}-invokes/cf_bundle_version`,
    value: "invokes/cf_bundle_version"
  }, "Count in installed version"), (rule.suffix === 'invokes/version' || platform.toLowerCase() === 'web') && React__namespace.createElement("option", {
    key: `${rule.id}-invokes/version`,
    value: "invokes/version"
  }, "Count in installed version"), React__namespace.createElement("option", {
    key: `${rule.id}-last_invoked_at/total`,
    value: "last_invoked_at/total"
  }, "Time since last seen"))), rule.suffix !== '' && React__namespace.createElement("div", {
    className: "select-option rule-comparator-selector"
  }, buildComparator({
    segment,
    rule,
    comparators,
    setCriteria,
    errors,
    setErrors
  })), rule.suffix !== '' && rule.comparator !== '' && React__namespace.createElement("div", {
    className: "app-input"
  }, buildPredicate$1({
    segment,
    rule,
    setCriteria,
    fetchAttributes,
    platform,
    errors,
    setErrors
  })), errorMessage ? React__namespace.createElement("div", {
    className: "error-message"
  }, errorMessage.message) : null, React__namespace.createElement("button", {
    className: "reasoning-button remove",
    title: "Remove Detail",
    type: "button",
    onClick: removeRule({
      segment,
      rule,
      setCriteria,
      setErrors
    })
  }, removeIcon$1)));
};
const renderRuleGeneric = _ref6 => {
  let {
    segment,
    rule,
    comparators,
    setCriteria,
    fetchAttributes,
    platform,
    errors,
    setErrors
  } = _ref6;
  const errorMessage = getError(rule, errors);
  return React__namespace.createElement("div", {
    className: "segment-rule generic-rule",
    key: `generic-${rule.id}`
  }, React__namespace.createElement("div", {
    className: "rule-label"
  }, React__namespace.createElement("span", null, cleanTitle(rule.key, rule.group)), buildTooltip(rule, platform)), React__namespace.createElement("div", {
    className: "select-option rule-comparator-selector"
  }, buildComparator({
    segment,
    rule,
    comparators,
    setCriteria,
    errors,
    setErrors
  })), React__namespace.createElement("div", {
    className: "app-input"
  }, buildPredicate$1({
    segment,
    rule,
    setCriteria,
    fetchAttributes,
    platform,
    errors,
    setErrors
  })), errorMessage ? React__namespace.createElement("div", {
    className: "error-message"
  }, errorMessage.message) : null, React__namespace.createElement("button", {
    className: "reasoning-button remove",
    title: "Remove Rule",
    type: "button",
    onClick: removeRule({
      segment,
      rule,
      setCriteria,
      setErrors
    })
  }, removeIcon$1));
};
var renderRuleGeneric$1 = renderRuleGeneric;

const renderEventRule = _ref => {
  var _events$items, _rule$key3;
  let {
    segment,
    rule,
    events,
    comparators,
    setCriteria,
    fetchAttributes,
    platform,
    fetchEvents,
    errors,
    setErrors
  } = _ref;
  const onTypeaheadInput = key => {
    if (!key.startsWith('local#app#')) {
      key = `local#app#${key}`;
    }
    validateField$1(rule, setErrors)({
      target: {
        value: key
      }
    });
    updateCriteria({
      key
    }, segment, rule, setCriteria, setErrors);
  };
  let options = [];
  let missingIndex = -1;
  if ((events === null || events === void 0 ? void 0 : (_events$items = events.items) === null || _events$items === void 0 ? void 0 : _events$items.length) > 0) {
    options = events.items.map(event => ({
      title: event.label.replace('local#app#', ''),
      value: event.label
    }));
    missingIndex = events.items.findIndex(event => {
      var _rule$key;
      return event.label.replace('local#app#', '') === (rule === null || rule === void 0 ? void 0 : (_rule$key = rule.key) === null || _rule$key === void 0 ? void 0 : _rule$key.replace('local#app#', ''));
    });
  }
  if (rule.key && missingIndex === -1) {
    var _rule$key2;
    console.warn('Adding missing key, likely an unseen Event.');
    const event = rule === null || rule === void 0 ? void 0 : (_rule$key2 = rule.key) === null || _rule$key2 === void 0 ? void 0 : _rule$key2.split('#')[2];
    options.push({
      title: event,
      value: event
    });
  }
  const addDetails = _event => {
    const details = {
      details: [...rule.details, {
        parent: rule.id,
        id: gguid(),
        type: 'number',
        comparator: '',
        suffix: '',
        value: 1
      }]
    };
    updateCriteria(details, segment, rule, setCriteria, setErrors);
  };
  const errorMessage = getError(rule, errors);
  return React__namespace.createElement("div", {
    className: "segment-rule-container",
    key: `${rule.id}-container`
  }, React__namespace.createElement("div", {
    className: "segment-rule event-rule",
    key: rule.id
  }, React__namespace.createElement("div", {
    className: "rule-label"
  }, React__namespace.createElement("span", null, "Has Seen Event")), React__namespace.createElement("div", {
    className: "events-selector"
  }, React__namespace.createElement(ApptentiveTypeahead$1, {
    fetchAttributes: fetchEvents,
    onBlur: validateField$1(rule, setErrors),
    onTypeaheadInput: onTypeaheadInput,
    rule: rule,
    ruleKey: "key",
    labelKeyAsync: option => {
      var _option$value;
      return `${option === null || option === void 0 ? void 0 : (_option$value = option.value) === null || _option$value === void 0 ? void 0 : _option$value.replace('local#app#', '')}`;
    },
    defaultOptions: options,
    defaultInputValue: rule === null || rule === void 0 ? void 0 : (_rule$key3 = rule.key) === null || _rule$key3 === void 0 ? void 0 : _rule$key3.replace('local#app#', ''),
    async: true,
    isInvalid: !!errorMessage
  })), React__namespace.createElement("button", {
    className: "reasoning-button add-details normalize",
    type: "button",
    onClick: addDetails,
    disabled: rule.key === ''
  }, "Add Details"), errorMessage ? React__namespace.createElement("div", {
    className: "error-message"
  }, errorMessage.message) : null, React__namespace.createElement("button", {
    className: "reasoning-button remove remove-event-parent",
    title: "Remove Rule",
    type: "button",
    onClick: removeRule({
      segment,
      rule,
      setCriteria,
      setErrors
    })
  }, removeIcon$1)), rule.details && rule.details.length > 0 ? React__namespace.createElement("div", {
    className: "detail-sub-rules"
  }, rule.details.map(detail => renderDetails({
    segment,
    parent: rule,
    rule: detail,
    comparators,
    setCriteria,
    fetchAttributes,
    platform,
    errors,
    setErrors
  }))) : null);
};
var renderEventRule$1 = renderEventRule;

const renderInteractionRule = _ref => {
  var _interactions$interac;
  let {
    segment,
    rule,
    interactions,
    comparators,
    setCriteria,
    fetchAttributes,
    platform,
    errors,
    setErrors
  } = _ref;
  const onChangeInteraction = event => {
    validateField$1(rule, setErrors)(event);
    if (event.target.value.startsWith('code_point/')) {
      const [, key] = event.target.value.split('/');
      updateCriteria({
        key
      }, segment, rule, setCriteria, setErrors);
      return;
    }
    updateCriteria({
      key: event.target.value
    }, segment, rule, setCriteria, setErrors);
  };
  let defaultValue = '';
  if (rule.key) {
    defaultValue = rule.key.startsWith('com.') ? `code_point/${rule.key}` : rule.key;
  }
  let surveys = null;
  let notes = null;
  let missing = null;
  let index = -1;
  if (interactions !== null && interactions !== void 0 && (_interactions$interac = interactions.interactions) !== null && _interactions$interac !== void 0 && _interactions$interac.options) {
    index = interactions.interactions.options.findIndex(interaction => interaction.id === defaultValue);
    surveys = interactions.interactions.options.filter(interaction => interaction.type === 'Survey').map(interaction => React__namespace.createElement("option", {
      value: interaction.id,
      key: interaction.id
    }, interaction.name));
    notes = interactions.interactions.options.filter(interaction => interaction.type === 'TextModal').map(interaction => React__namespace.createElement("option", {
      value: interaction.id,
      key: interaction.id
    }, interaction.name));
  } else {
    console.error('Interactions missing the `interactions` key!');
  }
  if (defaultValue && !defaultValue.startsWith('code_point/') && index === -1) {
    console.warn('Adding missing key, likely a deleted Interaction:', defaultValue);
    missing = React__namespace.createElement("option", {
      value: rule.key
    }, "Missing Interaction:", ' ', rule.key);
  }
  const addDetails = _event => {
    const details = {
      details: [...rule.details, {
        parent: rule.id,
        id: gguid(),
        type: 'number',
        comparator: '',
        suffix: '',
        value: undefined
      }]
    };
    updateCriteria(details, segment, rule, setCriteria, setErrors);
  };
  const errorMessage = getError(rule, errors);
  const className = classNames({
    interaction: true,
    'is-invalid': errorMessage && !rule.comparator
  });
  return React__namespace.createElement("div", {
    className: "segment-rule-container",
    key: `${rule.id}-container`
  }, React__namespace.createElement("div", {
    className: "segment-rule interaction-rule",
    key: rule.id
  }, React__namespace.createElement("div", {
    className: "rule-label"
  }, React__namespace.createElement("span", null, "Has Seen Interaction")), React__namespace.createElement("div", {
    className: "interactions-selector"
  }, React__namespace.createElement("select", {
    className: className,
    name: "interaction",
    defaultValue: defaultValue,
    onChange: onChangeInteraction,
    onBlur: validateField$1(rule, setErrors)
  }, React__namespace.createElement("option", {
    value: "",
    disabled: true
  }, "Select Interaction..."), missing, React__namespace.createElement("optgroup", {
    label: "Surveys"
  }, React__namespace.createElement("option", {
    value: "code_point/com.apptentive#Survey#launch"
  }, "Any Survey"), surveys), React__namespace.createElement("optgroup", {
    label: "Notes"
  }, React__namespace.createElement("option", {
    value: "code_point/com.apptentive#TextModal#launch"
  }, "Any Note"), notes), React__namespace.createElement("optgroup", {
    label: "Love Dialog"
  }, React__namespace.createElement("option", {
    value: "code_point/com.apptentive#EnjoymentDialog#launch"
  }, "Love Dialog Displayed"), React__namespace.createElement("option", {
    value: "code_point/com.apptentive#EnjoymentDialog#yes"
  }, "Selected \"Love\""), React__namespace.createElement("option", {
    value: "code_point/com.apptentive#EnjoymentDialog#no"
  }, "Selected \"Don't Love\"")), ['ios', 'android'].includes(platform.toLowerCase()) || defaultValue === 'code_point/com.apptentive#RatingDialog#launch' ? React__namespace.createElement("option", {
    value: "code_point/com.apptentive#RatingDialog#launch"
  }, "Apptentive Rating Dialog") : null, platform.toLowerCase() === 'ios' || defaultValue === 'code_point/com.apptentive#AppleRatingDialog#shown' ? React__namespace.createElement("option", {
    value: "code_point/com.apptentive#AppleRatingDialog#shown"
  }, "Apple Rating Dialog") : null, platform.toLowerCase() === 'android' || defaultValue === 'code_point/com.apptentive#InAppRatingDialog#shown' ? React__namespace.createElement("option", {
    value: "code_point/com.apptentive#InAppRatingDialog#shown"
  }, "Google Rating Dialog") : null)), React__namespace.createElement("button", {
    className: "reasoning-button add-details normalize",
    type: "button",
    onClick: addDetails,
    disabled: rule.key === ''
  }, "Add Details"), errorMessage ? React__namespace.createElement("div", {
    className: "error-message"
  }, errorMessage.message) : null, React__namespace.createElement("button", {
    className: "reasoning-button remove remove-interaction-parent",
    title: "Remove Rule",
    type: "button",
    onClick: removeRule({
      segment,
      rule,
      setCriteria,
      setErrors
    })
  }, removeIcon$1)), rule.details && rule.details.length > 0 ? React__namespace.createElement("div", {
    className: "detail-sub-rules"
  }, rule.details.map(detail => renderDetails({
    segment,
    parent: rule,
    rule: detail,
    comparators,
    setCriteria,
    fetchAttributes,
    platform,
    errors,
    setErrors
  }))) : null);
};
var renderInteractionRule$1 = renderInteractionRule;

const buildComparatorIRT = _ref => {
  let {
    segment,
    rule,
    interactions,
    comparators,
    setCriteria,
    errors,
    setErrors
  } = _ref;
  const onChange = event => {
    var _interactions$interac, _interactions$interac2;
    const option = interactions === null || interactions === void 0 ? void 0 : (_interactions$interac = interactions.interaction_response_targeting) === null || _interactions$interac === void 0 ? void 0 : (_interactions$interac2 = _interactions$interac.options) === null || _interactions$interac2 === void 0 ? void 0 : _interactions$interac2.find(choice => choice.key === rule.target);
    let suffix = 'answers/id';
    if (['range', 'singleline', 'nps'].includes(option === null || option === void 0 ? void 0 : option.type)) {
      suffix = 'answers/value';
    }
    if (rule.type === 'survey_question_other_text') {
      suffix = 'answers/value';
    }
    if (['$exists', '$notexists'].includes(event.target.value)) {
      const value = event.target.value === '$exists';
      validateField$1(rule, setErrors)(event);
      updateCriteria({
        comparator: event.target.value,
        value,
        suffix
      }, segment, rule, setCriteria, setErrors);
      return;
    }
    if (['$exists', '$notexists'].includes(rule.comparator)) {
      validateField$1(rule, setErrors)(event);
      updateCriteria({
        comparator: event.target.value,
        value: '',
        suffix
      }, segment, rule, setCriteria, setErrors);
      return;
    }
    validateField$1(rule, setErrors)(event);
    updateCriteria({
      comparator: event.target.value,
      suffix
    }, segment, rule, setCriteria, setErrors);
  };
  if (!comparators[rule.type]) {
    console.warn('No comparators for:', rule.type);
    return null;
  }
  const className = classNames({
    comparator: true,
    [`${rule.type}-type`]: true,
    'is-invalid': errors.length > 0 && !rule.comparator
  });
  return React__namespace.createElement("select", {
    className: className,
    key: `comparator-${rule.id}`,
    defaultValue: rule.comparator,
    onChange: onChange,
    onBlur: validateField$1(rule, setErrors)
  }, React__namespace.createElement("option", {
    key: `comparator-${rule.id}-missing`,
    value: "",
    disabled: true
  }, "Select a comparison..."), comparators[rule.type].map(c => React__namespace.createElement("option", {
    key: `comparator-${rule.id}-${c.class}`,
    value: c.value
  }, c.text)));
};
const buildPredicateIRT = _ref2 => {
  var _interactions$interac3, _interactions$interac4;
  let {
    segment,
    rule,
    interactions,
    setCriteria,
    errors,
    setErrors
  } = _ref2;
  const onInput = suffix => event => {
    const {
      type
    } = event.target;
    let {
      value
    } = event.target;
    if (type === 'number') {
      value = Number.parseFloat(value);
      if (Number.isNaN(value)) {
        console.error(`Error setting value "${event.target.value}" for type "${type}" in rule: ${rule.id} of parent rule: ${rule.parent}`);
        return;
      }
    }
    validateField$1(rule, setErrors)({
      target: {
        value
      }
    });
    updateCriteria({
      suffix,
      value
    }, segment, rule, setCriteria, setErrors);
  };
  const name = `input-${rule.id}`;
  const errorMessage = getError(rule, errors);
  let inputContainer = React__namespace.createElement("input", {
    name: name,
    value: rule.value,
    onChange: onInput('answers/value'),
    type: "text",
    className: classNames({
      'rule-predicate-input': true,
      text: true,
      'is-invalid': !!errorMessage
    }),
    onBlur: validateField$1(rule, setErrors)
  });
  const option = interactions === null || interactions === void 0 ? void 0 : (_interactions$interac3 = interactions.interaction_response_targeting) === null || _interactions$interac3 === void 0 ? void 0 : (_interactions$interac4 = _interactions$interac3.options) === null || _interactions$interac4 === void 0 ? void 0 : _interactions$interac4.find(choice => choice.interaction === rule.key && choice.key === rule.target);
  if (option && option.answer_choices) {
    const found = option.answer_choices.find(choice => choice.id === rule.value);
    const isText = rule.suffix === 'answers/value';
    let defaultValue = rule.value;
    let textValue = rule.value;
    if (!found && isText) {
      const other_question = option.answer_choices.find(choice => choice.type === 'select_other');
      if (other_question) {
        defaultValue = other_question.id;
      } else {
        console.error(`Provided answer "${rule.value}" not found, has the question been removed or updated?`);
      }
    } else if (found && found.type === 'select_other') {
      defaultValue = found.id;
      textValue = '';
    }
    inputContainer = React__namespace.createElement("div", {
      className: "select-choice"
    }, !rule.survey_other && React__namespace.createElement("select", {
      name: name,
      defaultValue: defaultValue,
      required: true,
      onChange: onInput('answers/id'),
      onBlur: validateField$1(rule, setErrors)
    }, React__namespace.createElement("option", {
      value: "",
      key: "default-answer-choice",
      disabled: true
    }, "Select Answer Choice..."), option.answer_choices.map(choice => React__namespace.createElement("option", {
      value: choice.id,
      key: choice.id
    }, choice.value))), isText ? React__namespace.createElement("input", {
      name: `${name}-other`,
      value: textValue,
      onChange: onInput('answers/value'),
      type: "text",
      className: classNames({
        'rule-predicate-input': true,
        'other-text': true,
        'is-invalid': !!errorMessage
      }),
      placeholder: "Other text containing...",
      onBlur: validateField$1(rule, setErrors)
    }) : null);
  }
  if (option && ['nps', 'range'].includes(option.type)) {
    inputContainer = React__namespace.createElement("input", {
      name: name,
      value: rule.value,
      onChange: onInput('answers/value'),
      type: "number",
      className: classNames({
        'rule-predicate-input': true,
        numeric: true,
        'is-invalid': !!errorMessage
      }),
      min: option.min,
      max: option.max,
      step: "1",
      pattern: "\\d*",
      onBlur: validateField$1(rule, setErrors)
    });
  }
  return inputContainer;
};
const buildRuleOptions = _ref3 => {
  var _interactions$interac5, _interactions$interac6;
  let {
    rule,
    parent,
    interactions
  } = _ref3;
  let output = interactions === null || interactions === void 0 ? void 0 : (_interactions$interac5 = interactions.interaction_response_targeting) === null || _interactions$interac5 === void 0 ? void 0 : (_interactions$interac6 = _interactions$interac5.options) === null || _interactions$interac6 === void 0 ? void 0 : _interactions$interac6.filter(choice => choice.interaction === rule.key);
  if (output.length === 0) {
    if (rule.target) {
      console.warn(`Adding missing option "${rule.target}", likely a deleted Parent Interaction.`);
      return [React__namespace.createElement("option", {
        value: rule.target,
        key: rule.key
      }, `Missing: ${rule.target}`)];
    }
    console.warn('No options, likely a deleted Parent Interaction.');
    return [];
  }
  let seenRule = false;
  if (parent.interactionType === 'Survey') {
    const questions = [];
    const other = [];
    for (const question of output) {
      if (!seenRule && rule.target === question.key) {
        seenRule = true;
      }
      if (Array.isArray(question.answer_choices) && question.answer_choices.some(choice => choice.type === 'select_other')) {
        other.push( React__namespace.createElement("option", {
          value: `${question.key}-other`,
          key: question.key
        }, question.name));
      }
      questions.push( React__namespace.createElement("option", {
        value: question.key,
        key: question.key
      }, question.name));
    }
    if (!seenRule && rule.target) {
      console.warn('Current rule was not found in the Survey options, adding it.');
      questions.push( React__namespace.createElement("option", {
        value: rule.target,
        key: rule.target
      }, `Missing: ${rule.target}`));
    }
    return React__namespace.createElement(React__namespace.Fragment, null, React__namespace.createElement("optgroup", {
      label: "Questions"
    }, questions), other.length > 0 && React__namespace.createElement("optgroup", {
      label: "Questions with Other Text"
    }, other));
  }
  output = output.map(choice => {
    if (!seenRule && rule.value === choice.key) {
      seenRule = true;
    }
    let label = choice.name;
    if (choice.interactionType) {
      var _interactions$interac7, _interactions$interac8;
      if (choice.interactionType === 'NavigateToLink' && choice.url) {
        label = `Link: ${choice.url}`;
      }
      const {
        name
      } = (interactions === null || interactions === void 0 ? void 0 : (_interactions$interac7 = interactions.interactions) === null || _interactions$interac7 === void 0 ? void 0 : (_interactions$interac8 = _interactions$interac7.options) === null || _interactions$interac8 === void 0 ? void 0 : _interactions$interac8.find(target => target.id === choice.target)) || {
        name: ''
      };
      if (choice.interactionType === 'Survey' && name) {
        label = `Survey: ${name}`;
      }
    }
    return React__namespace.createElement("option", {
      value: choice.key,
      key: choice.key
    }, label);
  });
  if (!seenRule && rule.value) {
    console.warn('Current rule was not found in the options, adding it.');
    output.push( React__namespace.createElement("option", {
      value: rule.value,
      key: rule.value
    }, `Missing: ${rule.value}`));
  }
  return output;
};
const renderInteractionResponseTargetingDetails = _ref4 => {
  let {
    segment,
    rule,
    parent,
    interactions,
    comparators,
    setCriteria,
    errors,
    setErrors
  } = _ref4;
  const onChangeTarget = event => {
    var _interactions$interac9, _interactions$interac10;
    let {
      value
    } = event.target;
    let type = 'survey_question';
    let suffix = 'answers/id';
    let survey_other = false;
    if (value.endsWith('-other')) {
      value = value.replace('-other', '');
      type = 'survey_question_other_text';
      suffix = 'answers/value';
      survey_other = true;
    }
    const option = interactions === null || interactions === void 0 ? void 0 : (_interactions$interac9 = interactions.interaction_response_targeting) === null || _interactions$interac9 === void 0 ? void 0 : (_interactions$interac10 = _interactions$interac9.options) === null || _interactions$interac10 === void 0 ? void 0 : _interactions$interac10.find(choice => choice.key === value);
    if (option) {
      if (survey_other) {
        value = value.replace('-other', '');
        type = 'survey_question_other_text';
        suffix = 'answers/value';
        validateField$1(rule, setErrors)(event);
        updateCriteria({
          target: value,
          type,
          value: '',
          suffix,
          survey_other
        }, segment, rule, setCriteria, setErrors);
        return;
      }
      type = getAttributeType(option.type);
      if (type === 'note_action') {
        suffix = 'answers/id';
        validateField$1(rule, setErrors)(event);
        updateCriteria({
          target: parent.key,
          type,
          value: option.key,
          suffix,
          survey_other
        }, segment, rule, setCriteria, setErrors);
        return;
      }
    }
    validateField$1(rule, setErrors)(event);
    updateCriteria({
      target: value,
      type,
      value: '',
      comparator: '',
      suffix,
      survey_other
    }, segment, rule, setCriteria, setErrors);
  };
  const rule_options = buildRuleOptions({
    rule,
    parent,
    interactions
  });
  let defaultValue = rule.value;
  if (parent.interactionType === 'Survey') {
    defaultValue = rule.survey_other ? `${rule.target}-other` : rule.target;
  }
  const errorMessage = getError(rule, errors);
  const targetClassName = classNames({
    'detail-type': true,
    'is-invalid': !rule.target && errors.length > 0
  });
  const hidePredicate = ['$exists', '$notexists'].includes(rule.comparator) || parent.interactionType === 'TextModal';
  let predicate = null;
  if (!hidePredicate) {
    predicate = buildPredicateIRT({
      segment,
      rule,
      interactions,
      setCriteria,
      errors,
      setErrors
    });
  }
  return React__namespace.createElement("div", {
    className: "segment-rule detail-sub-rule",
    key: `details-${rule.id}`
  }, React__namespace.createElement("div", {
    className: "segment-rule"
  }, React__namespace.createElement("div", {
    className: "select-option irt-label"
  }, React__namespace.createElement("select", {
    className: targetClassName,
    defaultValue: defaultValue,
    onChange: onChangeTarget,
    onBlur: validateField$1(rule, setErrors)
  }, React__namespace.createElement("option", {
    value: "",
    disabled: true
  }, parent.interactionType === 'Survey' ? 'Choose a Question...' : 'Choose an Action...'), rule_options)), rule.target !== '' && React__namespace.createElement("div", {
    className: "select-option rule-comparator-selector"
  }, buildComparatorIRT({
    segment,
    rule,
    interactions,
    comparators,
    setCriteria,
    errors,
    setErrors
  })), rule.target !== '' && rule.comparator !== '' && React__namespace.createElement("div", {
    className: "app-input"
  }, predicate), errorMessage ? React__namespace.createElement("div", {
    className: "error-message"
  }, errorMessage.message) : null, React__namespace.createElement("button", {
    className: "reasoning-button remove",
    title: "Remove Detail",
    type: "button",
    onClick: removeRule({
      segment,
      rule,
      setCriteria,
      setErrors
    })
  }, removeIcon$1)));
};
const renderInteractionResponseTargetingRule = _ref5 => {
  var _interactions$interac11, _rule$details;
  let {
    segment,
    rule,
    interactions,
    comparators,
    setCriteria,
    errors,
    setErrors,
    platform
  } = _ref5;
  if (errors && errors.length === 0) {
    validateRule(rule, setErrors);
  }
  const onChangeInteraction = event => {
    const key = event.target.value;
    validateField$1(rule, setErrors)(event);
    updateCriteria({
      key
    }, segment, rule, setCriteria, setErrors);
  };
  const onChangeInteractionType = event => {
    const interactionType = event.target.value;
    validateField$1(rule, setErrors)(event);
    updateCriteria({
      interactionType
    }, segment, rule, setCriteria, setErrors);
  };
  const parentInteraction = rule.key || '';
  let missing = null;
  let surveys = null;
  let index = -1;
  let notes = null;
  if (interactions !== null && interactions !== void 0 && (_interactions$interac11 = interactions.interactions) !== null && _interactions$interac11 !== void 0 && _interactions$interac11.options) {
    index = interactions.interactions.options.findIndex(interaction => interaction.id === parentInteraction);
    surveys = interactions.interactions.options.filter(interaction => interaction.type === 'Survey').map(interaction => React__namespace.createElement("option", {
      value: interaction.id,
      key: interaction.id
    }, interaction.name));
    notes = interactions.interactions.options.filter(interaction => interaction.type === 'TextModal').map(interaction => React__namespace.createElement("option", {
      value: interaction.id,
      key: interaction.id
    }, interaction.name));
  } else {
    console.error('Interactions missing `interactions` key!');
  }
  if (parentInteraction && !parentInteraction.startsWith('code_point/') && index === -1) {
    console.warn('Adding missing key, likely a deleted Parent Interaction:', parentInteraction);
    missing = React__namespace.createElement("option", {
      value: rule.key
    }, `Missing Interaction: ${rule.key}`);
  }
  const addDetails = _event => {
    const details = {
      details: [...rule.details, {
        parent: rule.id,
        id: gguid(),
        type: 'string',
        comparator: '',
        suffix: '',
        value: '',
        key: rule.key,
        target: ''
      }]
    };
    updateCriteria(details, segment, rule, setCriteria, setErrors);
  };
  const errorMessage = getError(rule, errors);
  const interactionTypeClassName = classNames({
    'interaction-type': true,
    'is-invalid': errorMessage && !rule.interactionType
  });
  const interactionClassName = classNames({
    interaction: true,
    'is-invalid': errorMessage && !parentInteraction
  });
  const detailsButtonClassName = classNames({
    'reasoning-button add-details normalize': true,
    'is-invalid': errorMessage && (rule === null || rule === void 0 ? void 0 : (_rule$details = rule.details) === null || _rule$details === void 0 ? void 0 : _rule$details.length) === 0
  });
  return React__namespace.createElement("div", {
    className: "segment-rule-container",
    key: `${rule.id}-container`
  }, React__namespace.createElement("div", {
    className: "segment-rule interaction-response-targeting-rule",
    key: rule.id
  }, React__namespace.createElement("div", {
    className: "rule-label"
  }, React__namespace.createElement("span", null, "Has Responded to Interaction")), React__namespace.createElement("div", {
    className: "interactions-selector"
  }, React__namespace.createElement("select", {
    className: interactionTypeClassName,
    name: "interaction-type",
    defaultValue: rule.interactionType || '',
    onChange: onChangeInteractionType,
    disabled: rule.details && rule.details.length > 0,
    onBlur: validateField$1(rule, setErrors)
  }, React__namespace.createElement("option", {
    value: "",
    disabled: true
  }, "Select Interaction Type..."), React__namespace.createElement("option", {
    value: "TextModal"
  }, "Notes"), React__namespace.createElement("option", {
    value: "Survey"
  }, "Surveys"), rule.interactionType === 'MISSING' ? React__namespace.createElement("option", {
    value: "MISSING"
  }, "Missing Interaction") : null), rule.interactionType && React__namespace.createElement("select", {
    className: interactionClassName,
    name: "interaction",
    defaultValue: parentInteraction,
    onChange: onChangeInteraction,
    disabled: rule.details && rule.details.length > 0,
    onBlur: validateField$1(rule, setErrors)
  }, React__namespace.createElement("option", {
    value: ""
  }, "Select Interaction..."), missing, rule.interactionType === 'Survey' && surveys, rule.interactionType === 'TextModal' && notes)), React__namespace.createElement("button", {
    className: detailsButtonClassName,
    type: "button",
    onClick: addDetails,
    disabled: rule.key === ''
  }, "Add Details"), platform === 'iOS' && !rule.interactionType && React__namespace.createElement("span", {
    className: "footnote"
  }, "Feature will only work on SDK v6.0 or higher."), errorMessage ? React__namespace.createElement("div", {
    className: "error-message"
  }, errorMessage.message) : null, React__namespace.createElement("button", {
    className: "reasoning-button remove remove-irt-parent",
    title: "Remove Rule",
    type: "button",
    onClick: removeRule({
      segment,
      rule,
      setCriteria,
      setErrors
    })
  }, removeIcon$1)), rule.details && rule.details.length > 0 ? React__namespace.createElement("div", {
    className: "detail-sub-rules"
  }, rule.details.map(detail => renderInteractionResponseTargetingDetails({
    segment,
    rule: detail,
    parent: rule,
    interactions,
    comparators,
    setCriteria,
    errors,
    setErrors
  }))) : null);
};
var renderInteractionResponseTargetingRule$1 = renderInteractionResponseTargetingRule;

const renderRuleFanSignals = _ref => {
  var _rule$details;
  let {
    segment,
    rule,
    setCriteria,
    setErrors
  } = _ref;
  const onChange = event => {
    const key = event.target.value;
    updateCriteria({
      key
    }, segment, rule, setCriteria, setErrors);
  };
  const setDate = index => date => {
    if (index === 0) {
      date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0));
    }
    if (index === 1) {
      date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999));
    }
    const value = Math.floor(date.getTime() / 1000);
    const {
      details
    } = rule;
    details[index].value = value;
    updateCriteria({
      details
    }, segment, rule, setCriteria, setErrors);
  };
  const addDetails = _event => {
    const date = new Date();
    const startDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0));
    const endDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999));
    const double = {
      details: [{
        parent: rule.id,
        id: gguid(),
        type: 'fan_signal',
        comparator: '$gte',
        value: Math.floor(startDate.getTime() / 1000) - 86400 * 30
      }, {
        parent: rule.id,
        id: gguid(),
        type: 'fan_signal',
        comparator: '$lte',
        value: Math.floor(endDate.getTime() / 1000)
      }]
    };
    updateCriteria(double, segment, rule, setCriteria, setErrors);
  };
  const removeDetails = _event => {
    const single = {
      details: [{
        parent: rule.id,
        id: gguid(),
        type: 'fan_signal',
        comparator: '$eq',
        value: true
      }]
    };
    updateCriteria(single, segment, rule, setCriteria, setErrors);
  };
  const options = ['Fan', 'ReclaimedFan', 'RepeatFan', 'Opportunity', 'LostFan', 'RepeatOpportunity'];
  return React__namespace.createElement("div", {
    className: "segment-rule-container",
    key: `fan-signals-${rule.id}`
  }, React__namespace.createElement("div", {
    className: "segment-rule fan-signals-rule"
  }, React__namespace.createElement("div", {
    className: "rule-label"
  }, React__namespace.createElement("span", null, "Fan Signal")), React__namespace.createElement("div", {
    className: "select-option rule-key-selector"
  }, React__namespace.createElement("select", {
    className: `fan-signal ${rule.type}`,
    key: `fan-signal-${rule.id}`,
    defaultValue: rule.key,
    onChange: onChange
  }, options.map(signal => React__namespace.createElement("option", {
    key: `fansignal-${rule.id}-${signal}`,
    value: signal
  }, cleanTitle(signal)))), React__namespace.createElement("button", {
    className: "reasoning-button add-details normalize",
    type: "button",
    disabled: (rule === null || rule === void 0 ? void 0 : (_rule$details = rule.details) === null || _rule$details === void 0 ? void 0 : _rule$details.length) > 1,
    onClick: addDetails
  }, "Add Details")), React__namespace.createElement("button", {
    className: "reasoning-button remove remove-fan-signal-parent",
    title: "Remove Rule",
    type: "button",
    onClick: removeRule({
      segment,
      rule,
      setCriteria,
      setErrors
    })
  }, removeIcon$1)), rule.details && rule.details.length === 2 ? React__namespace.createElement("div", {
    className: "detail-sub-rules"
  }, React__namespace.createElement("div", {
    className: "segment-rule detail-sub-rule fan-signals-details",
    key: `fan-signals-dates-${rule.id}`
  }, React__namespace.createElement("div", {
    className: "rule-label"
  }, React__namespace.createElement("span", null, "Shifted between"), React__namespace.createElement(InfoTooltip$1, null, "This will target all customers who became part of the selected Fan Signal group at least once during the time period you specify.")), React__namespace.createElement("div", {
    className: "date-start"
  }, React__namespace.createElement(DatePicker__default["default"], {
    key: `${rule.id}-gte`,
    dateFormat: "MMM d, yyyy",
    startDate: convertUTCToLocalDate(new Date(rule.details[0].value * 1000)),
    endDate: convertUTCToLocalDate(new Date(rule.details[1].value * 1000)),
    selected: convertUTCToLocalDate(new Date(rule.details[0].value * 1000)),
    maxDate: new Date((rule.details[1].value - 86400) * 1000),
    onChange: setDate(0),
    required: true,
    selectsStart: true
  })), React__namespace.createElement("div", {
    className: "date-end"
  }, React__namespace.createElement(DatePicker__default["default"], {
    key: `${rule.id}-lte`,
    dateFormat: "MMM d, yyyy",
    startDate: convertUTCToLocalDate(new Date(rule.details[0].value * 1000)),
    endDate: convertUTCToLocalDate(new Date(rule.details[1].value * 1000)),
    selected: convertUTCToLocalDate(new Date(rule.details[1].value * 1000)),
    minDate: new Date((rule.details[0].value + 86400) * 1000),
    maxDate: new Date().getTime(),
    onChange: setDate(1),
    required: true,
    selectsEnd: true
  })), React__namespace.createElement("div", {
    className: "utc"
  }, "UTC"), React__namespace.createElement("button", {
    className: "reasoning-button remove",
    title: "Remove Detail",
    type: "button",
    onClick: removeDetails
  }, removeIcon$1))) : null);
};
var renderRuleFanSignals$1 = renderRuleFanSignals;

const validateField = (rule, setErrors) => event => {
  var _event$target, _event$target2;
  let message = '';
  if (!(event !== null && event !== void 0 && (_event$target = event.target) !== null && _event$target !== void 0 && _event$target.value)) {
    message = 'This field is required.';
    setErrors(updateErrors(rule, message));
    return;
  }
  const value = Number.parseFloat(event === null || event === void 0 ? void 0 : (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.value).toPrecision(3);
  if (value <= 0.4) {
    message = 'Please enter a positive number greater than 0.4.';
  } else if (value > 99.5) {
    message = 'Please use a number between .1-99.5.';
  }
  setErrors(updateErrors(rule, message));
};
const renderRuleRandomSampling = _ref => {
  let {
    segment,
    rule,
    setCriteria,
    platform,
    setErrors,
    errors
  } = _ref;
  const onInput = event => {
    let value = event.target.type === 'number' ? Number.parseFloat(event.target.value) : event.target.value;
    value = Math.abs(value);
    value = Number.parseFloat(value.toFixed(1));
    if (Number.isNaN(value)) {
      value = undefined;
    }
    validateField(rule, setErrors)({
      target: {
        value
      }
    });
    updateCriteria({
      value
    }, segment, rule, setCriteria, setErrors);
  };
  const onKeyPress = e => {
    var _e$target;
    if (e.key === '.' && ((e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value.match(/\./g)) || []).length > 0) {
      e.preventDefault();
    }
    if (e.key === '-') {
      e.preventDefault();
    }
  };
  const name = `input-${rule.id}`;
  const errorMessage = getError(rule, errors);
  return React__default["default"].createElement("div", {
    className: "segment-rule-container",
    key: `random-sampling-${rule.id}`
  }, React__default["default"].createElement("div", {
    className: "segment-rule random-sampling-rule"
  }, React__default["default"].createElement("div", {
    className: "rule-label"
  }, React__default["default"].createElement("span", null, "Random Sampling:", React__default["default"].createElement("br", null), "Percent of customers")), React__default["default"].createElement("span", null, " \xA0is\xA0"), React__default["default"].createElement("div", {
    className: "app-input"
  }, React__default["default"].createElement("div", {
    className: "sample-input-container"
  }, React__default["default"].createElement("input", {
    type: "number",
    className: classNames({
      'rule-predicate-input': true,
      'is-invalid': errorMessage
    }),
    required: true,
    min: "0.5",
    max: "99.5",
    step: "0.5",
    onChange: onInput,
    defaultValue: rule.value,
    onBlur: validateField(rule, setErrors),
    name: name,
    key: name,
    onKeyPress: onKeyPress
  }), React__default["default"].createElement("span", null, "%")), ['iOS', 'Android'].includes(platform) ? React__default["default"].createElement(React__default["default"].Fragment, null, React__default["default"].createElement("br", null), React__default["default"].createElement("span", {
    className: "footnote"
  }, "Feature will only work on", ' ', platform, ' ', "SDK v", platform === 'iOS' ? '5.3.4' : '5.7.0', ' ', "or higher.")) : null), errorMessage ? React__default["default"].createElement("div", {
    className: "error-message"
  }, errorMessage.message) : null, React__default["default"].createElement("button", {
    className: "reasoning-button remove remove-random-sampling-parent",
    title: "Remove Rule",
    type: "button",
    onClick: removeRule({
      segment,
      rule,
      setCriteria,
      setErrors
    })
  }, removeIcon$1)));
};
var renderRuleRandomSampling$1 = renderRuleRandomSampling;

const renderOption = (option, _ref) => {
  let {
    cursor,
    setCursor,
    selected,
    setValue
  } = _ref;
  const {
    className,
    index,
    label,
    value
  } = option;
  const isSelected = value === selected;
  const isCursor = index === cursor;
  const onClick = event => {
    if (event.button !== 0) {
      return;
    }
    event.stopPropagation();
    event.preventDefault();
    setValue(value, label);
  };
  const onKeyPress = event => {
    if (event.key === 'Enter') {
      setValue(value, label);
    }
  };
  const onFocus = () => {
    setCursor(index);
  };
  let group = '';
  if (value.includes('/')) {
    [group] = value.split('/');
  }
  const classNames = `dropdown-option ${group} ${className} ${isSelected ? 'selected' : ''} ${isCursor ? 'hover' : ''}`.trim();
  return React__default["default"].createElement("div", {
    key: value,
    id: `dropdown-${value}`,
    className: classNames,
    onKeyPress: onKeyPress,
    onClick: onClick,
    onFocus: onFocus,
    onMouseEnter: onFocus,
    onMouseLeave: () => setCursor(undefined),
    role: "option",
    "aria-selected": isSelected ? 'true' : 'false',
    "data-index": index,
    tabIndex: 0
  }, label);
};
const buildMenu = (options, _ref2) => {
  let {
    cursor,
    setCursor,
    selected,
    setValue
  } = _ref2;
  if (!options || options.length === 0) {
    return React__default["default"].createElement("div", {
      className: "dropdown-noresults",
      key: "no-results",
      role: "listbox"
    }, "No Options");
  }
  const output = [];
  for (const [index, option] of options.entries()) {
    option.index = index;
    if (option.group) {
      const groupIndex = output.findIndex(entry => entry.name === option.group);
      if (groupIndex > -1) {
        output[groupIndex].items.push(option);
      } else {
        output.push({
          name: option.group,
          items: [option]
        });
      }
    } else {
      output.push(option);
    }
  }
  return output.map(option => {
    if (option.items) {
      return React__default["default"].createElement("div", {
        className: "dropdown-group",
        key: option.name,
        role: "listbox",
        tabIndex: "-1"
      }, React__default["default"].createElement("div", {
        className: `dropdown-title ${option.name.toLowerCase().replace(/\s/g, '-')}`
      }, option.name), option.items.map(item => renderOption(item, {
        cursor,
        setCursor,
        selected,
        setValue
      })));
    }
    return renderOption(option, {
      cursor,
      setCursor,
      selected,
      setValue
    });
  });
};
const handleRootMouseDown = (_ref3, _ref4) => {
  let {
    disabled
  } = _ref3;
  let {
    open,
    setOpen
  } = _ref4;
  return event => {
    if (event.button !== 0) {
      return;
    }
    event.stopPropagation();
    event.preventDefault();
    if (!disabled) {
      setOpen(!open);
    }
  };
};
const handleRootKeyDown = (_ref5, _ref6) => {
  let {
    disabled,
    options
  } = _ref5;
  let {
    open,
    setOpen,
    cursor,
    setCursor,
    setValue
  } = _ref6;
  return event => {
    if (!['Space', 'Enter', 'Escape', 'ArrowDown', 'ArrowUp'].includes(event.key)) {
      return;
    }
    event.stopPropagation();
    event.preventDefault();
    if (event.key === 'Escape') {
      setOpen(false);
      return;
    }
    if (!open && !disabled && ['Space', 'Enter', 'ArrowDown', 'ArrowUp'].includes(event.key)) {
      setOpen(true);
      return;
    }
    if (['ArrowDown', 'ArrowUp'].includes(event.key)) {
      if (!Number.isInteger(cursor)) {
        setCursor(0);
        return;
      }
      const direction = event.key === 'ArrowUp' ? -1 : 1;
      const next = cursor + direction;
      if (next > -1 && next < options.length) {
        setCursor(next);
        return;
      }
    }
    if (event.key === 'Enter') {
      const {
        value,
        label
      } = options[cursor];
      setValue(value, label);
    }
  };
};
const Dropdown = function Dropdown(props) {
  const {
    options = [],
    defaultValue = '',
    disabled = false,
    className = '',
    showSelected = true,
    placeholder = 'Select...',
    onChange = () => {}
  } = props;
  const [open, setOpen] = React.useState(false);
  const defaultOption = defaultValue ? options.find(o => o.value === defaultValue) : {};
  const [selected, setSelected] = React.useState((defaultOption === null || defaultOption === void 0 ? void 0 : defaultOption.label) || defaultValue || placeholder);
  const [cursor, setCursor] = React.useState(options.findIndex(o => o.value === defaultValue));
  const dropdownRef = React.useRef(null);
  React.useEffect(() => {
    const handleDocumentClick = event => {
      if (dropdownRef && dropdownRef.current && !dropdownRef.current.contains(event.target) && open) {
        setOpen(false);
      }
    };
    document.addEventListener('click', handleDocumentClick, false);
    return function cleanup() {
      document.removeEventListener('click', handleDocumentClick, false);
    };
  });
  const setValue = (value, label) => {
    setSelected(label);
    setOpen(false);
    onChange(value);
  };
  return React__default["default"].createElement("div", {
    ref: dropdownRef,
    className: `dropdown-root ${className} ${open ? 'is-open' : ''}`
  }, React__default["default"].createElement("div", {
    className: `dropdown-control ${disabled ? 'dropdown-disabled' : ''}`,
    onMouseDown: handleRootMouseDown(props, {
      open,
      setOpen,
      dropdownRef
    }),
    onKeyDown: handleRootKeyDown(props, {
      open,
      setOpen,
      cursor,
      setCursor,
      dropdownRef,
      setValue
    }),
    role: "button",
    "aria-haspopup": "listbox",
    tabIndex: 0
  }, React__default["default"].createElement("div", {
    className: `dropdown-placeholder ${selected !== placeholder ? 'is-selected' : ''}`
  }, showSelected ? selected : placeholder), React__default["default"].createElement("div", {
    className: "dropdown-arrow-wrapper"
  }, React__default["default"].createElement("span", {
    className: "dropdown-arrow"
  }))), open ? React__default["default"].createElement("div", {
    className: "dropdown-menu",
    "aria-expanded": "true"
  }, buildMenu(options, {
    cursor,
    setCursor,
    selected,
    setValue
  })) : null);
};
var Dropdown$1 = Dropdown;

const processText = (rule, text) => {
  let values = [];
  let inQuotes = false;
  for (let row = 0, i = 0; i < text.length; i++) {
    const currentCharacter = text[i];
    const nextCharacter = text[i + 1];
    values[row] = values[row] || '';
    if (currentCharacter === '\\' && inQuotes && nextCharacter === '"') {
      values[row] += nextCharacter;
      ++i;
      continue;
    }
    if (currentCharacter === '"') {
      inQuotes = !inQuotes;
      continue;
    }
    if (currentCharacter === ',' && !inQuotes) {
      ++row;
      continue;
    }
    if (currentCharacter === '\r' && nextCharacter === '\n' && !inQuotes) {
      ++row;
      ++i;
      continue;
    }
    if (['\n', '\r'].includes(currentCharacter) && !inQuotes) {
      ++row;
      continue;
    }
    values[row] += currentCharacter;
  }
  values = values.map(item => {
    item = item.trim();
    if (rule.type === 'number') {
      item = Number.parseFloat(item);
      if (Number.isNaN(item)) {
        item = undefined;
      }
    }
    return item;
  }).filter(Boolean);
  const old = values.length;
  values = [...new Set(values)];
  const duplicates = old - values.length;
  return [values, duplicates];
};
const showOverLimitError = _ref => {
  let {
    total,
    limit,
    setModalContent,
    setModalOpen
  } = _ref;
  const close = _event => {
    setModalContent('');
    setModalOpen(false);
  };
  setModalContent( React__namespace.createElement("div", {
    className: "limit-error"
  }, React__namespace.createElement("strong", null, "Error: Maximum Values Exceeded"), React__namespace.createElement("p", null, "The items you are attempting to add exceeds our current", ' ', limit.toLocaleString(), ' ', "value maximum by", ' ', React__namespace.createElement("strong", null, (total - limit).toLocaleString(), ' ', "value(s).")), React__namespace.createElement("p", null, "Please reduce the number of items and try again. Thank you!"), React__namespace.createElement("button", {
    className: "normalize close-modal",
    type: "button",
    onClick: close,
    onKeyDown: close
  }, "Okay")));
  setModalOpen(true);
};
const showGenericError = _ref2 => {
  let {
    title,
    body,
    setModalContent,
    setModalOpen
  } = _ref2;
  const close = _event => {
    setModalContent('');
    setModalOpen(false);
  };
  setModalContent( React__namespace.createElement("div", {
    className: "limit-error"
  }, React__namespace.createElement("strong", null, title), React__namespace.createElement("p", null, body), React__namespace.createElement("button", {
    className: "normalize",
    type: "button",
    onClick: close,
    onKeyDown: close
  }, "Okay")));
  setModalOpen(true);
};
const buildPredicate = _ref3 => {
  let {
    segment,
    rule,
    setCriteria,
    errors,
    setErrors,
    setModalContent,
    setModalOpen,
    limit
  } = _ref3;
  const onPaste = event => {
    const paste = (event.clipboardData || window.clipboardData).getData('text');
    const [values] = processText(rule, paste);
    if (values.length > limit) {
      event.preventDefault();
      console.error(`Pasted content has too many items: ${values.length}, ${values.length - limit} over the ${limit} limit.`);
      showOverLimitError({
        total: values.length,
        limit,
        setModalContent,
        setModalOpen
      });
      return false;
    }
    if (values.length + rule.value.length > limit) {
      event.preventDefault();
      console.error(`Pasted content would add too many items: ${values.length}, ${values.length + rule.value.length - limit} over the ${limit} limit.`);
      showOverLimitError({
        total: values.length + rule.value.length,
        limit,
        setModalContent,
        setModalOpen
      });
      return false;
    }
    return true;
  };
  const onKeydown = event => {
    const [values] = processText(rule, event.target.value.trim());
    const key = event.keyCode || event.charCode;
    const deleteKeystroke = key === 8 || key === 46;
    if (!deleteKeystroke && values.length > limit) {
      event.preventDefault();
      console.error(`Too many items entered: ${values.length}, ${values.length - limit} over the ${limit} limit. Please remove items first.`);
      showOverLimitError({
        total: values.length,
        limit,
        setModalContent,
        setModalOpen
      });
      return false;
    }
    return true;
  };
  const onInput = event => {
    var _event$target;
    if (!(event !== null && event !== void 0 && (_event$target = event.target) !== null && _event$target !== void 0 && _event$target.value)) {
      updateCriteria({
        value: [],
        duplicates: 0
      }, segment, rule, setCriteria, setErrors);
      setErrors(updateErrors(rule, 'This field is required.'));
      return false;
    }
    const [values, duplicates] = processText(rule, event.target.value.trim());
    if (values.length > limit) {
      console.error(`Too many items entered: ${values.length}, ${values.length - limit} over the ${limit} limit.`);
      showOverLimitError({
        total: values.length,
        limit,
        setModalContent,
        setModalOpen
      });
      return false;
    }
    setErrors(updateErrors(rule, ''));
    updateCriteria({
      value: values,
      duplicates
    }, segment, rule, setCriteria, setErrors);
    return true;
  };
  const name = `input-${rule.id}`;
  const errorMessage = getError(rule, errors);
  const defaultValue = rule.value.map(item => {
    if (typeof item === 'object' && !Array.isArray(item) && item !== null) {
      if (item._type === 'version') {
        item = String(item.version);
      }
      if (item._type === 'datetime') {
        item = String(item.sec);
      }
    }
    item = String(item);
    if (item.includes(',')) {
      if (item.includes('"')) {
        item = item.replaceAll('"', '\\"');
      }
      item = `"${item}"`;
    }
    return item;
  }).join(', ');
  const onFile = event => {
    const inputElement = event.target;
    const files = inputElement.files ? Array.from(inputElement.files) : [];
    const [file] = files;
    if (!file) {
      console.error('No file selected.');
      return;
    }
    const {
      size,
      type
    } = file;
    if (!['text/plain', 'text/csv'].includes(type)) {
      console.error('Invalid file type:', type);
      showGenericError({
        title: 'Error: Unacceptable File Type',
        body: 'Please add a single column CSV file or a TXT file only. All other files types are unacceptable for this action.',
        setModalContent,
        setModalOpen
      });
      return;
    }
    if (size > 1024 * 1024) {
      console.error('File too large:', size);
      showGenericError({
        title: 'Error: Unacceptable File Size',
        body: 'Please add a smaller file, less than 1MB.',
        setModalContent,
        setModalOpen
      });
      return;
    }
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      const [values, duplicates] = processText(rule, reader.result);
      if (values.length > limit) {
        console.error(`Too many items entered: ${values.length}, ${values.length - limit} over the ${limit} limit.`);
        showOverLimitError({
          total: values.length,
          limit,
          setModalContent,
          setModalOpen
        });
        return false;
      }
      setErrors(updateErrors(rule, ''));
      updateCriteria({
        value: values,
        duplicates
      }, segment, rule, setCriteria, setErrors);
      if (document.querySelector(`#${name}`)) {
        document.querySelector(`#${name}`).value = values.map(value => {
          if (value.includes(',') || value.includes('"')) {
            return `"${value.replace(/"/g, '\\"')}"`;
          }
          return value;
        }).join(', ');
      }
      return false;
    }, false);
    reader.readAsText(file);
  };
  const fieldName = `${name}-file-upload`;
  return React__namespace.createElement("div", {
    className: "bulk-wrapper app-input"
  }, React__namespace.createElement("textarea", {
    id: name,
    name: name,
    key: name,
    className: classNames({
      'rule-predicate-input': true,
      text: true,
      'is-invalid': errorMessage || defaultValue.length === 0
    }),
    required: true,
    defaultValue: defaultValue,
    onBlur: onInput,
    onInput: onInput,
    onKeyDown: onKeydown,
    onPaste: onPaste,
    rows: 5,
    placeholder: "Enter a comma seperated list of values"
  }), React__namespace.createElement("div", {
    className: "bulk-status"
  }, React__namespace.createElement("div", {
    className: "bulk-action"
  }, React__namespace.createElement("label", {
    htmlFor: fieldName,
    className: "custom-file-upload"
  }, "Add values from a file", React__namespace.createElement("input", {
    id: fieldName,
    name: fieldName,
    className: "file-upload-input",
    type: "file",
    onChange: onFile,
    multiple: false,
    accept: "*.csv,*.txt"
  })), React__namespace.createElement(InfoTooltip$1, null, "Instructions:", React__namespace.createElement("ul", null, React__namespace.createElement("li", null, "Acceptable upload formats include single-column CSV files without headers, and TXT files"), React__namespace.createElement("li", null, "When manually entering your target values in the input field, values need to be comma separated")))), React__namespace.createElement("div", {
    className: "bulk-total"
  }, `${rule.value.length.toLocaleString()} values${rule.duplicates !== 0 ? `, ${rule.duplicates.toLocaleString()} duplicate values removed.` : ''}`)), React__namespace.createElement("div", {
    className: "bulk-error-container"
  }, errorMessage ? React__namespace.createElement("div", {
    className: "error-message"
  }, errorMessage.message) : null));
};
const renderBulkUpload = _ref4 => {
  let {
    segment,
    rule,
    avaliableRules,
    comparators,
    setCriteria,
    attributes,
    platform,
    errors = [],
    setErrors,
    setModalContent,
    setModalOpen
  } = _ref4;
  if (errors.length === 0) {
    validateRule(rule, setErrors);
  }
  const {
    limit
  } = avaliableRules.find(r => r.value === 'bulk-upload') || {
    limit: 1000
  };
  const updateRuleKey = newKey => {
    const type = getAttributeType(newKey, attributes);
    let group = '';
    let key = '';
    if (newKey.includes('/custom_data/')) {
      [group,, key] = newKey.split('/');
      key = `custom_data/${key}`;
    } else {
      [group, key] = newKey.split('/');
    }
    const details = {
      details: [{ ...rule.details[0],
        comparator: '$eq',
        group,
        key,
        type
      }]
    };
    updateCriteria(details, segment, rule, setCriteria, setErrors);
  };
  avaliableRules = avaliableRules.filter(r => ['Person & Device Data', 'Device Custom Data', 'Person Custom Data'].includes(r.group) && ['number', 'string', 'version'].includes(r.type));
  const newComparators = JSON.parse(JSON.stringify(comparators));
  for (const [type, values] of Object.entries(newComparators)) {
    for (const [i, comparator] of values.entries()) {
      if (comparator && comparator.value === '$ne') {
        values[i] = undefined;
      }
    }
    newComparators[type] = values.filter(Boolean);
  }
  const errorMessage = getError(rule, errors);
  const defaultValue = rule.details[0].group && rule.details[0].key ? `${rule.details[0].group}/${rule.details[0].key}` : '';
  const targetValueClassName = classNames({
    'select-option rule-target-selector': true,
    'is-invalid': errorMessage && !rule.details[0].key
  });
  return React__namespace.createElement("div", {
    className: "segment-rule-container",
    key: `${rule.id}-container`
  }, React__namespace.createElement("div", {
    className: "segment-rule bulk-rule",
    key: rule.id
  }, React__namespace.createElement("div", {
    className: "rule-label"
  }, React__namespace.createElement("span", null, "Add a list to build targeting rules")), React__namespace.createElement("div", {
    className: targetValueClassName
  }, React__namespace.createElement(Dropdown$1, {
    defaultValue: defaultValue,
    options: avaliableRules,
    onChange: newKey => updateRuleKey(newKey),
    placeholder: "Select Target Value...",
    showSelected: true,
    onBlur: validateField$1(rule, setErrors),
    disabled: errors.length !== 0 && rule.details[0].key
  })), React__namespace.createElement("div", {
    className: "select-option rule-comparator-selector"
  }, buildComparator({
    segment,
    rule: rule.details[0],
    comparators: newComparators,
    setCriteria,
    errors,
    setErrors
  })), React__namespace.createElement("span", {
    className: "footnote"
  }, "Feature will only work on SDK v3.4 or higher."), React__namespace.createElement("button", {
    className: "reasoning-button remove remove-event-parent",
    title: "Remove Rule",
    type: "button",
    onClick: removeRule({
      segment,
      rule,
      setCriteria,
      setErrors
    })
  }, removeIcon$1)), defaultValue ? React__namespace.createElement("div", {
    className: "detail-sub-rules"
  }, React__namespace.createElement("div", {
    className: "segment-rule detail-sub-rule bulk-upload-rule"
  }, buildPredicate({
    segment,
    rule: rule.details[0],
    setCriteria,
    platform,
    errors,
    setErrors,
    setModalContent,
    setModalOpen,
    limit
  }))) : null, errorMessage ? React__namespace.createElement("div", {
    className: "error-message"
  }, errorMessage.message) : null);
};
var renderBulkUpload$1 = renderBulkUpload;

const Modal = function Modal(_ref) {
  let {
    content,
    title = 'Modal',
    open,
    onClose,
    onOpen,
    setModalContent,
    setModalOpen
  } = _ref;
  const close = event => {
    if (onClose) onClose(event);
    setModalOpen(false);
    setModalContent('');
  };
  const modalRef = React.useRef(null);
  React.useEffect(() => {
    const handleDocumentClick = event => {
      if (modalRef && modalRef.current && !modalRef.current.contains(event.target)) {
        close(event);
      }
    };
    const handleDocumentKeyDown = event => {
      if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
        close(event);
      }
    };
    if (modalRef && modalRef.current) {
      modalRef.current.focus();
    }
    document.addEventListener('click', handleDocumentClick, false);
    document.addEventListener('keydown', handleDocumentKeyDown, false);
    return function cleanup() {
      document.removeEventListener('click', handleDocumentClick, false);
      document.removeEventListener('keydown', handleDocumentKeyDown, false);
    };
  });
  React.useEffect(() => {
    if (open && onOpen) {
      onOpen();
    }
  }, [open, onOpen]);
  if (!open || !content) {
    return null;
  }
  return React__default["default"].createElement("div", {
    className: "reasoning-modal-overlay"
  }, React__default["default"].createElement("div", {
    className: "reasoning-modal-dialog",
    role: "dialog",
    "aria-label": title,
    tabIndex: "-1",
    ref: modalRef
  }, content));
};
var Modal$1 = Modal;

const buildNewRule = (value, attributes) => {
  const id = gguid();
  switch (value) {
    case 'Fan':
    case 'ReclaimedFan':
    case 'RepeatFan':
    case 'Opportunity':
    case 'LostFan':
    case 'RepeatOpportunity':
    case 'fs_state':
      {
        return {
          id,
          group: 'fs_state',
          key: value,
          type: 'parent',
          details: [{
            parent: id,
            id: gguid(),
            type: 'fan_signal',
            comparator: '$eq',
            value: true
          }]
        };
      }
    case 'random':
      {
        return {
          id,
          group: 'random',
          key: '__ID__',
          comparator: '$lt',
          type: 'number',
          value: 5
        };
      }
    case 'interaction_response_targeting':
      {
        return {
          id,
          group: value,
          key: '',
          type: 'parent',
          details: []
        };
      }
    case 'code_point':
    case 'interactions':
      {
        return {
          id,
          group: value,
          key: '',
          type: 'parent',
          details: [{
            parent: id,
            id: gguid(),
            type: 'number',
            comparator: '$eq',
            suffix: 'invokes/total',
            value: 1
          }]
        };
      }
    case 'bulk-upload':
      {
        return {
          id,
          group: 'bulk-upload',
          key: '',
          type: 'parent',
          details: [{
            parent: id,
            id: gguid(),
            comparator: '$eq',
            value: [],
            key: undefined,
            group: undefined,
            duplicates: 0,
            type: 'string'
          }]
        };
      }
    default:
      {
        const type = getAttributeType(value, attributes);
        const defaultValue = getDefaultValueForType(type);
        if (value.includes('/custom_data/')) {
          const [group,, key] = value.split('/');
          return {
            id,
            group,
            type,
            key: `custom_data/${key}`,
            comparator: '$eq',
            value: defaultValue
          };
        }
        let [group, key] = value.split('/');
        if (group && typeof key === 'undefined') {
          key = group;
          group = '';
        }
        return {
          id,
          group,
          key,
          type,
          comparator: '$eq',
          value: defaultValue
        };
      }
  }
};
const addRule = _ref => {
  let {
    value,
    segment_id,
    attributes,
    setCriteria
  } = _ref;
  const rule = buildNewRule(value, attributes);
  setCriteria(criteria => {
    const copyCriteria = [...criteria];
    const segment_index = copyCriteria.findIndex(s => s.id === segment_id);
    const segment = copyCriteria[segment_index];
    const newSegment = { ...segment,
      rules: [...segment.rules, rule]
    };
    copyCriteria.splice(segment_index, 1, newSegment);
    return copyCriteria;
  });
};
const removeSegment = _ref2 => {
  let {
    id,
    rules,
    setCriteria,
    setErrors
  } = _ref2;
  return _event => {
    const ids = rules.reduce((output, rule) => {
      var _rule$details;
      output.push(rule.id);
      if ((rule === null || rule === void 0 ? void 0 : (_rule$details = rule.details) === null || _rule$details === void 0 ? void 0 : _rule$details.length) > 0) {
        output.push(...rule.details.map(detail => detail.id));
      }
      return output;
    }, []);
    setErrors(errors => errors.filter(error => !ids.includes(error.id)));
    setCriteria(criteria => {
      const copyCriteria = [...criteria];
      const index = copyCriteria.findIndex(s => s.id === id);
      copyCriteria.splice(index, 1);
      return copyCriteria;
    });
  };
};
const renderRule = _ref3 => {
  let {
    segment,
    rule,
    avaliableRules,
    events,
    interactions,
    comparators,
    setCriteria,
    attributes,
    fetchAttributes,
    fetchEvents,
    platform,
    errors,
    setErrors,
    setModalContent,
    setModalOpen
  } = _ref3;
  let output = null;
  switch (rule.group) {
    case 'random':
      output = renderRuleRandomSampling$1({
        segment,
        rule,
        comparators,
        setCriteria,
        platform,
        errors,
        setErrors
      });
      break;
    case 'code_point':
      output = renderEventRule$1({
        segment,
        rule,
        events,
        comparators,
        setCriteria,
        fetchEvents,
        fetchAttributes,
        platform,
        errors,
        setErrors
      });
      break;
    case 'interactions':
      output = renderInteractionRule$1({
        segment,
        rule,
        interactions,
        comparators,
        setCriteria,
        fetchAttributes,
        platform,
        errors,
        setErrors
      });
      break;
    case 'interaction_response_targeting':
      output = renderInteractionResponseTargetingRule$1({
        segment,
        rule,
        interactions,
        comparators,
        setCriteria,
        errors,
        setErrors,
        platform
      });
      break;
    case 'fs_state':
      output = renderRuleFanSignals$1({
        segment,
        rule,
        setCriteria,
        errors,
        setErrors
      });
      break;
    case 'device':
    case 'person':
    case 'application':
      output = renderRuleGeneric$1({
        segment,
        rule,
        comparators,
        setCriteria,
        fetchAttributes,
        platform,
        errors,
        setErrors
      });
      break;
    case 'bulk-upload':
      output = renderBulkUpload$1({
        segment,
        rule,
        avaliableRules,
        events,
        comparators,
        setCriteria,
        fetchEvents,
        attributes,
        fetchAttributes,
        platform,
        errors,
        setErrors,
        setModalContent,
        setModalOpen
      });
      break;
    default:
      console.warn(`renderRule: Unknown Group: "${rule.group}" for ${rule.key}`);
      output = renderRuleGeneric$1({
        segment,
        rule,
        comparators,
        setCriteria,
        fetchAttributes,
        platform,
        errors,
        setErrors
      });
  }
  return output;
};
const renderSegment = (_ref4, _ref5) => {
  let {
    id,
    rules
  } = _ref4;
  let {
    events,
    interactions,
    comparators,
    attributes,
    avaliableRules,
    newCriteria,
    setCriteria,
    fetchAttributes,
    fetchEvents,
    platform,
    errors,
    setErrors,
    setModalOpen,
    setModalContent,
    overallLimit
  } = _ref5;
  const hasFanSignals = rules.filter(rule => rule.group === 'fs_state').length > 0;
  if (hasFanSignals) {
    avaliableRules = avaliableRules.filter(option => option.group !== 'Fan Signals');
  }
  const hasRandomSampling = rules.filter(rule => rule.group === 'random').length > 0;
  if (hasRandomSampling) {
    avaliableRules = avaliableRules.filter(option => option.group !== 'Random Sampling');
  }
  const segmentRuleCount = countRules(newCriteria, id);
  const totalRuleCount = countRules(newCriteria);
  const countClassnames = classNames({
    'rule-counts': true,
    'over-limit': totalRuleCount > overallLimit
  });
  return React__default["default"].createElement(React__default["default"].Fragment, {
    key: `segment-${id}`
  }, React__default["default"].createElement("form", {
    className: "segment",
    onSubmit: function onSubmit(e) {
      e.preventDefault();
    }
  }, rules.length > 0 ? rules.map(rule => renderRule({
    segment: id,
    rule,
    avaliableRules,
    events,
    interactions,
    comparators,
    setCriteria,
    attributes,
    fetchAttributes,
    fetchEvents,
    platform,
    errors,
    setErrors,
    setModalOpen,
    setModalContent
  })) : React__default["default"].createElement("div", {
    className: "add-some-rules",
    key: "add-some-rules"
  }, React__default["default"].createElement("h4", null, "Add Some Rules"), React__default["default"].createElement("p", null, "Begin building your segment with a rule.")), React__default["default"].createElement("div", {
    className: "rule-footer"
  }, React__default["default"].createElement(Dropdown$1, {
    options: avaliableRules,
    onChange: value => addRule({
      value,
      segment_id: id,
      attributes,
      setCriteria
    }),
    placeholder: "Add a Rule...",
    showSelected: false,
    disabled: errors.length !== 0
  }), React__default["default"].createElement("div", {
    className: countClassnames
  }, segmentRuleCount.toLocaleString(), ' ', "rules out of", ' ', totalRuleCount.toLocaleString(), ' ', "total rules.", totalRuleCount === overallLimit ? ` You are at the rule limit of ${overallLimit.toLocaleString()}.` : '', totalRuleCount > overallLimit ? ` You are ${(totalRuleCount - overallLimit).toLocaleString()} over the rule limit of ${overallLimit.toLocaleString()}.` : ''), React__default["default"].createElement("button", {
    className: "reasoning-button normalize delete-segment",
    type: "button",
    onClick: removeSegment({
      id,
      rules,
      setCriteria,
      setErrors
    })
  }, "Delete Segment"))), React__default["default"].createElement("div", {
    className: "or-divider"
  }, "OR"));
};
const addSegment = setCriteria => _event => {
  setCriteria(criteria => [...criteria, {
    id: gguid(),
    type: '$and',
    rules: []
  }]);
};
const buildCriteria = _ref6 => {
  let {
    newCriteria,
    setCriteria,
    errors,
    setErrors,
    setModalContent,
    setModalOpen,
    events,
    interactions,
    comparators,
    attributes,
    avaliableRules,
    fetchAttributes,
    fetchEvents,
    platform,
    overallLimit
  } = _ref6;
  if (!newCriteria || newCriteria.length === 0) {
    return React__default["default"].createElement("div", {
      className: "no-segments"
    }, React__default["default"].createElement("h3", null, "Targeting Everyone"), React__default["default"].createElement("p", null, "Add a segment and then rules to target groups of customers or devices."));
  }
  return newCriteria.map(segment => {
    if (segment.type === '$and') {
      return renderSegment(segment, {
        events,
        interactions,
        comparators,
        attributes,
        avaliableRules,
        newCriteria,
        setCriteria,
        fetchAttributes,
        fetchEvents,
        platform,
        errors,
        setErrors,
        setModalContent,
        setModalOpen,
        overallLimit
      });
    }
    console.warn('Unexpected Segment Type:', segment.type);
  }).filter(Boolean);
};
const augmentRules = _ref7 => {
  let {
    attributes,
    avaliableRules,
    irt,
    platform,
    random,
    bulkUpload,
    bulkUploadLimit,
    overallLimit,
    fanSignals
  } = _ref7;
  let newRules = [...avaliableRules];
  if (attributes) {
    var _attributes$device, _attributes$person;
    if ((attributes === null || attributes === void 0 ? void 0 : (_attributes$device = attributes.device) === null || _attributes$device === void 0 ? void 0 : _attributes$device.fields.length) > 0) {
      for (const {
        type,
        name,
        key
      } of attributes.device.fields) {
        if (key.includes('custom_data')) {
          newRules.push({
            group: 'Device Custom Data',
            label: name.replace('custom_data.', ''),
            value: `device/${key.replace('custom_data.', 'custom_data/')}`,
            className: 'device-custom-data',
            type
          });
        }
      }
    }
    if ((attributes === null || attributes === void 0 ? void 0 : (_attributes$person = attributes.person) === null || _attributes$person === void 0 ? void 0 : _attributes$person.fields.length) > 0) {
      for (const {
        type,
        name,
        key
      } of attributes.person.fields) {
        if (key.includes('custom_data')) {
          newRules.push({
            group: 'Person Custom Data',
            label: name.replace('custom_data.', ''),
            value: `person/${key.replace('custom_data.', 'custom_data/')}`,
            className: 'person-custom-data',
            type
          });
        }
      }
    }
  }
  if (fanSignals === false) {
    newRules = newRules.filter(rule => rule.group !== 'Fan Signals');
  }
  if (irt === false) {
    newRules = newRules.filter(rule => rule.value !== 'interaction_response_targeting');
  }
  if (random === false) {
    newRules = newRules.filter(rule => rule.value !== 'random');
  }
  if (platform) {
    newRules = newRules.filter(rule => {
      if (rule.platform) {
        return rule.platform.includes(platform.toLowerCase());
      }
      return true;
    });
  }
  if (bulkUpload) {
    newRules.unshift({
      className: 'bulk-upload',
      label: 'Add a list to build targeting rules',
      value: 'bulk-upload',
      limit: Math.min(bulkUploadLimit, overallLimit)
    });
  }
  return newRules;
};
const SegmentBuilder = function SegmentBuilder(_ref8) {
  let {
    criteria = {},
    events = {},
    interactions = {},
    comparators = defaultComparators,
    attributes = {},
    avaliableRules = defaultRules$1,
    onChange = () => {},
    fetchAttributes = () => {},
    fetchEvents = () => {},
    irt = true,
    platform = '',
    debug = false,
    disabled = false,
    random = true,
    bulkUpload = false,
    bulkUploadLimit = 1000,
    overallLimit = 1000,
    fanSignals = false
  } = _ref8;
  const [loading, setLoading] = React.useState(true);
  const [removeOnly, setRemoveOnly] = React.useState(false);
  const [newEvents, setEvents] = React.useState(events);
  const [oldCriteria, _setOldCriteria] = React.useState(criteria);
  const [newCriteria, setCriteria] = React.useState([]);
  const [augmentedRules, setAugmentedRules] = React.useState([]);
  const [errors, setErrors] = React.useState([]);
  const [modalContent, setModalContent] = React.useState();
  const [modalOpen, setModalOpen] = React.useState(false);
  const onChangeCallback = React.useCallback(data => onChange(data), [onChange]);
  useDeepCompareEffect$1(() => {
    if (debug) {
      console.log('✨ Input Criteria:', oldCriteria);
    }
    setLoading(true);
    const builerCriteria = injestCriteria({
      criteria: oldCriteria,
      interactions,
      attributes
    });
    setCriteria(builerCriteria);
    setLoading(false);
  }, [oldCriteria, interactions]);
  React.useEffect(() => {
    if (Array.isArray(newEvents)) {
      console.log('🛠 Cleaning Events:', newEvents);
      setEvents({
        items: newEvents
      });
    }
  }, [newEvents]);
  useDeepCompareEffect$1(() => {
    setAugmentedRules(augmentRules({
      attributes,
      avaliableRules,
      irt,
      platform,
      random,
      bulkUpload,
      bulkUploadLimit,
      overallLimit,
      fanSignals
    }));
  }, [attributes, irt, platform, random, bulkUpload, bulkUploadLimit, overallLimit, fanSignals]);
  React.useEffect(() => {
    if (loading) {
      console.log('⏳ Loading...');
      return;
    }
    const total = countRules(newCriteria);
    if (total >= overallLimit) {
      console.warn(`You are at or over the rule limit, ${total} of ${overallLimit}.`);
      setRemoveOnly(true);
    } else if (removeOnly) {
      setRemoveOnly(false);
    }
    const converted = convertToCiteria(newCriteria);
    if (debug) {
      console.log('✨ New Criteria:', newCriteria);
      console.log('🔮 Converted', converted);
      console.log('🐛 Errors', errors);
    }
    if (total <= overallLimit && !disabled && errors.length === 0) {
      console.log('📝 Callback Sent', converted);
      onChangeCallback(converted);
    }
  }, [loading, debug, onChangeCallback, newCriteria, disabled, errors, overallLimit, removeOnly]);
  const className = classNames({
    reasoning: true,
    disabled,
    'remove-only': removeOnly
  });
  return React__default["default"].createElement("div", {
    className: className,
    key: "reasoning-logic-editor"
  }, React__default["default"].createElement(Modal$1, {
    title: "Logic Editor Modal",
    content: modalContent,
    open: modalOpen,
    setModalOpen: setModalOpen,
    setModalContent: setModalContent
  }), buildCriteria({
    newCriteria,
    setCriteria,
    errors,
    setErrors,
    setModalContent,
    setModalOpen,
    events: newEvents,
    interactions,
    comparators,
    attributes,
    fetchAttributes,
    fetchEvents,
    platform,
    avaliableRules: augmentedRules,
    overallLimit
  }), React__default["default"].createElement("button", {
    className: "reasoning-button add-segment",
    type: "button",
    disabled: errors.length !== 0,
    onClick: addSegment(setCriteria)
  }, "Add Segment"));
};

exports.addRule = addRule;
exports.addSegment = addSegment;
exports.augmentRules = augmentRules;
exports.buildCriteria = buildCriteria;
exports.buildNewRule = buildNewRule;
exports["default"] = SegmentBuilder;
exports.removeSegment = removeSegment;
exports.renderRule = renderRule;
exports.renderSegment = renderSegment;
//# sourceMappingURL=SegmentBuilder.js.map
